import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  Unit_instanceat14thlj150z as Unit_instance,
  closeFinally1sadm0w9gt3u4 as closeFinally,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trimEnd17pt8cbotbalj as trimEnd,
  toString1pkumu07cwy4m as toString,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  Enum3alwj03lh1n41 as Enum,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  captureStack1fzi4aczwc4hg as captureStack,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  sorted354mfsiv4s7x5 as sorted,
  joinToString1cxrrlmo0chqs as joinToString,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  Regexxgw0gjiagf4z as Regex,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toList3jhuyej2anx2q as toList,
  Char19o2r8palgjof as Char,
  drop3na99dw9feawf as drop,
  plus310ted5e4i90h as plus,
  startsWith26w8qjqapeeq6 as startsWith,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
  toByte8i5slur4dl5l as toByte,
  toShort1p4eva4kktrqr as toShort,
  toInt5qdj874w69jh as toInt,
  toLong3pjhmef5dakl7 as toLong,
  toDouble1kn912gjoizjp as toDouble,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  singleOrNull2irkcw0xgriv8 as singleOrNull,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  StringBuildermazzzhj6kkai as StringBuilder,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  lines3g90sq0zeq43v as lines,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  Comparator2b3maoeh98xtg as Comparator,
  compareTo3ankvs086tmwq as compareTo,
  sortedWith2csnbbb21k0lg as sortedWith,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  to2cs3ny02qtbcb as to,
  singleo93pzdgfc557 as single,
  listOfvhqybd2zx248 as listOf,
  first58ocm7j58k3q as first,
  until1jbpn0z3f8lbg as until,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  firstOrNull1982767dljvdy as firstOrNull,
  getKClass1s3j9wy1cofik as getKClass,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  listOf1jh22dvmctj1r as listOf_0,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  toString14fd7g605f91p as toString_1,
  contains2el4s70rdq4ld as contains,
  trimMarginhyd3fsmh8iev as trimMargin,
  plus20p0vtfmu0596 as plus_0,
  createThis2j2avj17cvnv2 as createThis,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  last1vo29oleiqj36 as last,
  toList383f556t1dixk as toList_0,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toSet2orjxp16sotqu as toSet,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  protoOf180f3jzyo7rfj as protoOf,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
} from './kotlin-kotlin-stdlib.mjs';
import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  OBJECT_getInstanceoefnxtom5aro as OBJECT_getInstance,
  CLASS3e32wwn6b97hz as CLASS,
  CONTEXTUAL2e1gz2tojnpmj as CONTEXTUAL,
  MAPtg3mcyan4256 as MAP,
  LIST2gzos3vzn3slg as LIST,
  ENUMlmq49cvwy4ow as ENUM,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  LONG2pk1o9ze1il7c as LONG,
  SHORTo7q5gsuxaxs as SHORT,
  INT3fyso8r94fmo5 as INT,
  FLOAT2bpqq59z4fuiu as FLOAT,
  DOUBLExcx7tue0m1mu as DOUBLE,
  CHARm37y40it075g as CHAR,
  BYTE3998jn8in9237 as BYTE,
  BOOLEANwrdyi6z6g9t5 as BOOLEAN,
  STRINGrrr0wq2m1c2f as STRING,
  OBJECT2nknkrqb4pf7m as OBJECT,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  MAP_getInstance242ky2ofgg8p5 as MAP_getInstance,
  CLASS_getInstanceycyg9nehd7tt as CLASS_getInstance,
  LIST_getInstance31r89469rgwkw as LIST_getInstance,
  OPEN_getInstance1g2m5lmphyw5 as OPEN_getInstance,
  SEALED_getInstance2brzxtciy6zxg as SEALED_getInstance,
  get_elementNamesl5b6t976dltd as get_elementNames,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  Buffer3384y49aj0pxr as Buffer,
  Companion_getInstance3qk4c089etcnv as Companion_getInstance,
} from './okio-parent-okio.mjs';
import {
  StreamDataWriter22wnutt6wwhrc as StreamDataWriter,
  NodeEvent1xqamwd0s6axm as NodeEvent,
  AliasEvent18arfb3x5sd0q as AliasEvent,
  MappingStartEvent1lr1mcqmcpbry as MappingStartEvent,
  SequenceStartEvent27qj1ypmim9wn as SequenceStartEvent,
  ScalarEvent1tfmd4lt1nu9c as ScalarEvent,
  ID_SequenceEnd_getInstanceb13eoodp77ng as ID_SequenceEnd_getInstance,
  ID_MappingEnd_getInstance3oeh8or6dnpbq as ID_MappingEnd_getInstance,
  ID_Scalar_getInstanceh2aagh7mrmog as ID_Scalar_getInstance,
  ScalarStyle_PLAIN_getInstance1qxa2fn26s70 as ScalarStyle_PLAIN_getInstance,
  CommentEvent3en0kmzv7bnjy as CommentEvent,
  CommentType_BLOCK_getInstance1y622ny5jaxzl as CommentType_BLOCK_getInstance,
  FlowStyle_BLOCK_getInstance2cmcgl68iyrit as FlowStyle_BLOCK_getInstance,
  FlowStyle_FLOW_getInstance2z6lpgfr3ei4u as FlowStyle_FLOW_getInstance,
  ScalarStyle_DOUBLE_QUOTED_getInstance2xzzd54rqi0xo as ScalarStyle_DOUBLE_QUOTED_getInstance,
  ScalarStyle_SINGLE_QUOTED_getInstance3q0lylgqm93qn as ScalarStyle_SINGLE_QUOTED_getInstance,
  ScalarStyle_LITERAL_getInstance2e18nzmfjlkw0 as ScalarStyle_LITERAL_getInstance,
  ImplicitTuple2t3yly3nn5jjs as ImplicitTuple,
  Companion_instance3eslhq1ib5vcs as Companion_instance,
  Emitter2x4oouz03mc86 as Emitter,
  StreamStartEventyoou3t7h4s0x as StreamStartEvent,
  DocumentStartEvent3czq54u492q97 as DocumentStartEvent,
  MappingEndEvent9dqshhk3o3ws as MappingEndEvent,
  SequenceEndEvent2iybmagh9ma3o as SequenceEndEvent,
  DocumentEndEvent3ar4xivn3l8hu as DocumentEndEvent,
  StreamEndEvent3qera3kv81k33 as StreamEndEvent,
  MarkedYamlEngineExceptionra3nsv6mim88 as MarkedYamlEngineException,
  Companion_instance31eh1xd51bs0b as Companion_instance_0,
  StreamReader2jtln3s95380r as StreamReader,
  ParserImpl2xms7a4twiiy as ParserImpl,
  ID_StreamStart_getInstance2p0sinvtx3c21 as ID_StreamStart_getInstance,
  ID_StreamEnd_getInstance3qhqjqxk61lxm as ID_StreamEnd_getInstance,
  ID_DocumentStart_getInstanceukn405q5ykqt as ID_DocumentStart_getInstance,
  ID_DocumentEnd_getInstance1lnckvi2jzakq as ID_DocumentEnd_getInstance,
} from './snakeyaml-engine-kmp.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Location {
  constructor(line, column) {
    this.ue1_1 = line;
    this.ve1_1 = column;
  }
  toString() {
    return 'Location(line=' + this.ue1_1 + ', column=' + this.ve1_1 + ')';
  }
  hashCode() {
    var result = this.ue1_1;
    result = imul(result, 31) + this.ve1_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Location))
      return false;
    var tmp0_other_with_cast = other instanceof Location ? other : THROW_CCE();
    if (!(this.ue1_1 === tmp0_other_with_cast.ue1_1))
      return false;
    if (!(this.ve1_1 === tmp0_other_with_cast.ve1_1))
      return false;
    return true;
  }
}
class Companion {
  constructor() {
    Companion_instance_1 = this;
    this.we1_1 = new Yaml();
  }
}
class Yaml {
  constructor(serializersModule, configuration) {
    Companion_getInstance_0();
    serializersModule = serializersModule === VOID ? EmptySerializersModule() : serializersModule;
    configuration = configuration === VOID ? new YamlConfiguration() : configuration;
    this.xe1_1 = serializersModule;
    this.ye1_1 = configuration;
  }
  mz() {
    return this.xe1_1;
  }
  g1h(deserializer, string) {
    return this.ge2(deserializer, bufferedSource(string));
  }
  ge2(deserializer, source) {
    var rootNode = this.he2(source);
    var input = Companion_getInstance_1().je2(rootNode, this, this.xe1_1, this.ye1_1, deserializer.yu());
    return input.wy(deserializer);
  }
  he2(source) {
    var parser = new YamlParser(source, this.ye1_1.ce3_1);
    var reader = new YamlNodeReader(parser, this.ye1_1.qe2_1, this.ye1_1.ae3_1);
    var node = reader.y1n();
    parser.le3();
    return node;
  }
  f1h(serializer, value) {
    var buffer = new Buffer();
    encodeToBufferedSink(this, serializer, value, buffer);
    // Inline function 'kotlin.text.trimEnd' call
    var this_0 = buffer.lde();
    return toString(trimEnd(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  }
}
class BufferedSinkDataWriter {
  constructor(sink) {
    this.me3_1 = sink;
  }
  gd() {
    return this.me3_1.gd();
  }
  d1l(str) {
    this.me3_1.wde(str);
  }
  ddk(str, off, len) {
    this.me3_1.xde(str, off, off + len | 0);
  }
  p6() {
    this.gd();
  }
}
class YamlComment {}
class YamlConfiguration {
  constructor(encodeDefaults, strictMode, extensionDefinitionPrefix, polymorphismStyle, polymorphismPropertyName, encodingIndentationSize, breakScalarsAt, sequenceStyle, singleLineStringStyle, multiLineStringStyle, ambiguousQuoteStyle, sequenceBlockIndent, allowAnchorsAndAliases, yamlNamingStrategy, codePointLimit) {
    encodeDefaults = encodeDefaults === VOID ? true : encodeDefaults;
    strictMode = strictMode === VOID ? true : strictMode;
    extensionDefinitionPrefix = extensionDefinitionPrefix === VOID ? null : extensionDefinitionPrefix;
    polymorphismStyle = polymorphismStyle === VOID ? PolymorphismStyle_Tag_getInstance() : polymorphismStyle;
    polymorphismPropertyName = polymorphismPropertyName === VOID ? 'type' : polymorphismPropertyName;
    encodingIndentationSize = encodingIndentationSize === VOID ? 2 : encodingIndentationSize;
    breakScalarsAt = breakScalarsAt === VOID ? 80 : breakScalarsAt;
    sequenceStyle = sequenceStyle === VOID ? SequenceStyle_Block_getInstance() : sequenceStyle;
    singleLineStringStyle = singleLineStringStyle === VOID ? SingleLineStringStyle_DoubleQuoted_getInstance() : singleLineStringStyle;
    multiLineStringStyle = multiLineStringStyle === VOID ? singleLineStringStyle.pe3() : multiLineStringStyle;
    ambiguousQuoteStyle = ambiguousQuoteStyle === VOID ? AmbiguousQuoteStyle_DoubleQuoted_getInstance() : ambiguousQuoteStyle;
    sequenceBlockIndent = sequenceBlockIndent === VOID ? 0 : sequenceBlockIndent;
    allowAnchorsAndAliases = allowAnchorsAndAliases === VOID ? false : allowAnchorsAndAliases;
    yamlNamingStrategy = yamlNamingStrategy === VOID ? null : yamlNamingStrategy;
    codePointLimit = codePointLimit === VOID ? null : codePointLimit;
    this.oe2_1 = encodeDefaults;
    this.pe2_1 = strictMode;
    this.qe2_1 = extensionDefinitionPrefix;
    this.re2_1 = polymorphismStyle;
    this.se2_1 = polymorphismPropertyName;
    this.te2_1 = encodingIndentationSize;
    this.ue2_1 = breakScalarsAt;
    this.ve2_1 = sequenceStyle;
    this.we2_1 = singleLineStringStyle;
    this.xe2_1 = multiLineStringStyle;
    this.ye2_1 = ambiguousQuoteStyle;
    this.ze2_1 = sequenceBlockIndent;
    this.ae3_1 = allowAnchorsAndAliases;
    this.be3_1 = yamlNamingStrategy;
    this.ce3_1 = codePointLimit;
  }
  toString() {
    return 'YamlConfiguration(encodeDefaults=' + this.oe2_1 + ', strictMode=' + this.pe2_1 + ', extensionDefinitionPrefix=' + this.qe2_1 + ', polymorphismStyle=' + this.re2_1.toString() + ', polymorphismPropertyName=' + this.se2_1 + ', encodingIndentationSize=' + this.te2_1 + ', breakScalarsAt=' + this.ue2_1 + ', sequenceStyle=' + this.ve2_1.toString() + ', singleLineStringStyle=' + this.we2_1.toString() + ', multiLineStringStyle=' + this.xe2_1.toString() + ', ambiguousQuoteStyle=' + this.ye2_1.toString() + ', sequenceBlockIndent=' + this.ze2_1 + ', allowAnchorsAndAliases=' + this.ae3_1 + ', yamlNamingStrategy=' + toString_0(this.be3_1) + ', codePointLimit=' + this.ce3_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.oe2_1);
    result = imul(result, 31) + getBooleanHashCode(this.pe2_1) | 0;
    result = imul(result, 31) + (this.qe2_1 == null ? 0 : getStringHashCode(this.qe2_1)) | 0;
    result = imul(result, 31) + this.re2_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.se2_1) | 0;
    result = imul(result, 31) + this.te2_1 | 0;
    result = imul(result, 31) + this.ue2_1 | 0;
    result = imul(result, 31) + this.ve2_1.hashCode() | 0;
    result = imul(result, 31) + this.we2_1.hashCode() | 0;
    result = imul(result, 31) + this.xe2_1.hashCode() | 0;
    result = imul(result, 31) + this.ye2_1.hashCode() | 0;
    result = imul(result, 31) + this.ze2_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ae3_1) | 0;
    result = imul(result, 31) + (this.be3_1 == null ? 0 : hashCode(this.be3_1)) | 0;
    result = imul(result, 31) + (this.ce3_1 == null ? 0 : this.ce3_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlConfiguration))
      return false;
    var tmp0_other_with_cast = other instanceof YamlConfiguration ? other : THROW_CCE();
    if (!(this.oe2_1 === tmp0_other_with_cast.oe2_1))
      return false;
    if (!(this.pe2_1 === tmp0_other_with_cast.pe2_1))
      return false;
    if (!(this.qe2_1 == tmp0_other_with_cast.qe2_1))
      return false;
    if (!this.re2_1.equals(tmp0_other_with_cast.re2_1))
      return false;
    if (!(this.se2_1 === tmp0_other_with_cast.se2_1))
      return false;
    if (!(this.te2_1 === tmp0_other_with_cast.te2_1))
      return false;
    if (!(this.ue2_1 === tmp0_other_with_cast.ue2_1))
      return false;
    if (!this.ve2_1.equals(tmp0_other_with_cast.ve2_1))
      return false;
    if (!this.we2_1.equals(tmp0_other_with_cast.we2_1))
      return false;
    if (!this.xe2_1.equals(tmp0_other_with_cast.xe2_1))
      return false;
    if (!this.ye2_1.equals(tmp0_other_with_cast.ye2_1))
      return false;
    if (!(this.ze2_1 === tmp0_other_with_cast.ze2_1))
      return false;
    if (!(this.ae3_1 === tmp0_other_with_cast.ae3_1))
      return false;
    if (!equals(this.be3_1, tmp0_other_with_cast.be3_1))
      return false;
    if (!(this.ce3_1 == tmp0_other_with_cast.ce3_1))
      return false;
    return true;
  }
}
class SingleLineStringStyle extends Enum {
  pe3() {
    var tmp;
    switch (this.p3_1) {
      case 0:
        tmp = MultiLineStringStyle_DoubleQuoted_getInstance();
        break;
      case 1:
        tmp = MultiLineStringStyle_SingleQuoted_getInstance();
        break;
      case 2:
        tmp = MultiLineStringStyle_Plain_getInstance();
        break;
      case 3:
        tmp = MultiLineStringStyle_Plain_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
class MultiLineStringStyle extends Enum {}
class PolymorphismStyle extends Enum {}
class SequenceStyle extends Enum {}
class AmbiguousQuoteStyle extends Enum {}
class YamlInput extends AbstractDecoder {
  constructor(node, yaml, serializersModule, configuration) {
    Companion_getInstance_1();
    super();
    this.ke2_1 = node;
    this.le2_1 = yaml;
    this.me2_1 = serializersModule;
    this.ne2_1 = configuration;
  }
  mz() {
    return this.me2_1;
  }
  wy(deserializer) {
    try {
      return super.wy(deserializer);
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var e = $p;
        throwIfMissingRequiredPropertyException(this, e);
        throw e;
      } else {
        throw $p;
      }
    }
  }
}
class YamlContextualInput extends YamlInput {
  oz(descriptor) {
    throw IllegalStateException.h5('Must call beginStructure() and use returned Decoder');
  }
  hy() {
    throw IllegalStateException.h5('Must call beginStructure() and use returned Decoder');
  }
  xy(descriptor) {
    return Companion_getInstance_1().je2(this.ke2_1, this.le2_1, this.mz(), this.ne2_1, descriptor);
  }
}
class YamlException extends SerializationException {
  static ge5(message, path, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.bw(message, cause);
    captureStack($this, $this.fe5_1);
    $this.ze4_1 = message;
    $this.ae5_1 = path;
    $this.be5_1 = cause;
    $this.ce5_1 = $this.ae5_1.hea_1;
    $this.de5_1 = $this.ce5_1.ue1_1;
    $this.ee5_1 = $this.ce5_1.ve1_1;
    return $this;
  }
  fe() {
    return this.ze4_1;
  }
  ge() {
    return this.be5_1;
  }
  toString() {
    return '' + getKClassFromExpression(this).yf() + ' at ' + this.ae5_1.vea() + ' on line ' + this.de5_1 + ', column ' + this.ee5_1 + ': ' + this.fe();
  }
  get message() {
    return this.fe();
  }
  get cause() {
    return this.ge();
  }
}
class IncorrectTypeException extends YamlException {
  static ue4(message, path) {
    var $this = this.ge5(message, path);
    captureStack($this, $this.te4_1);
    return $this;
  }
}
class MissingTypeTagException extends IncorrectTypeException {
  static he4(path) {
    var $this = this.ue4('Value is missing a type tag (eg. !<type>)', path);
    captureStack($this, $this.ge4_1);
    return $this;
  }
}
class InvalidPropertyValueException extends YamlException {
  static ve5(propertyName, reason, path, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.ge5("Value for '" + propertyName + "' is invalid: " + reason, path, cause);
    captureStack($this, $this.ue5_1);
    $this.se5_1 = propertyName;
    $this.te5_1 = reason;
    return $this;
  }
}
class MissingRequiredPropertyException extends YamlException {
  static je6(propertyName, path, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.ge5("Property '" + propertyName + "' is required but it is missing.", path, cause);
    captureStack($this, $this.ie6_1);
    $this.he6_1 = propertyName;
    return $this;
  }
}
class EmptyYamlDocumentException extends YamlException {
  static we6(message, path) {
    var $this = this.ge5(message, path);
    captureStack($this, $this.ve6_1);
    return $this;
  }
}
class MalformedYamlException extends YamlException {
  static je7(message, path) {
    var $this = this.ge5(message, path);
    captureStack($this, $this.ie7_1);
    return $this;
  }
}
class ForbiddenAnchorOrAliasException extends YamlException {
  static we7(message, path) {
    var $this = this.ge5(message, path);
    captureStack($this, $this.ve7_1);
    return $this;
  }
}
class NoAnchorForExtensionException extends YamlException {
  static le8(key, extensionDefinitionPrefix, path) {
    var $this = this.ge5("The key '" + key + "' starts with the extension definition prefix '" + extensionDefinitionPrefix + "' but does not define an anchor.", path);
    captureStack($this, $this.ke8_1);
    $this.ie8_1 = key;
    $this.je8_1 = extensionDefinitionPrefix;
    return $this;
  }
}
class UnknownAnchorException extends YamlException {
  static ze8(anchorName, path) {
    var $this = this.ge5("Unknown anchor '" + anchorName + "'.", path);
    captureStack($this, $this.ye8_1);
    $this.xe8_1 = anchorName;
    return $this;
  }
}
class YamlScalarFormatException extends YamlException {
  static ne9(message, path, originalValue) {
    var $this = this.ge5(message, path);
    captureStack($this, $this.me9_1);
    $this.le9_1 = originalValue;
    return $this;
  }
}
class DuplicateKeyException extends YamlException {
  static fea(originalPath, duplicatePath, key) {
    var $this = this.ge5('Duplicate key ' + key + '. It was previously given at line ' + originalPath.hea_1.ue1_1 + ', column ' + originalPath.hea_1.ve1_1 + '.', duplicatePath);
    captureStack($this, $this.eea_1);
    $this.ze9_1 = originalPath;
    $this.aea_1 = duplicatePath;
    $this.bea_1 = key;
    $this.cea_1 = $this.ze9_1.hea_1;
    $this.dea_1 = $this.aea_1.hea_1;
    return $this;
  }
}
class UnexpectedNullValueException extends YamlException {
  static uea(path) {
    var $this = this.ge5('Unexpected null or empty value for non-null field.', path);
    captureStack($this, $this.tea_1);
    return $this;
  }
}
class UnknownPropertyException extends YamlException {
  static keb(propertyName, validPropertyNames, path) {
    var $this = this.ge5("Unknown property '" + propertyName + "'. Known properties are: " + joinToString(sorted(validPropertyNames), ', '), path);
    captureStack($this, $this.jeb_1);
    $this.heb_1 = propertyName;
    $this.ieb_1 = validPropertyNames;
    return $this;
  }
}
class UnknownPolymorphicTypeException extends YamlException {
  static zeb(typeName, validTypeNames, path, cause) {
    cause = cause === VOID ? null : cause;
    var $this = this.ge5("Unknown type '" + typeName + "'. Known types are: " + joinToString(sorted(validTypeNames), ', '), path, cause);
    captureStack($this, $this.yeb_1);
    $this.web_1 = typeName;
    $this.xeb_1 = validTypeNames;
    return $this;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = "^Field '(.*)' is required for type with serial name '.*', but it was missing$";
    tmp.ie2_1 = Regex.pi(this_0);
  }
  je2(node, yaml, context, configuration, descriptor) {
    var tmp;
    if (node instanceof YamlNull) {
      var tmp_0;
      var tmp_1;
      var tmp_2 = descriptor.gx();
      if (tmp_2 instanceof PolymorphicKind) {
        tmp_1 = !descriptor.ww();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        throw MissingTypeTagException.he4(node.fec_1);
      } else {
        tmp_0 = new YamlNullInput(node, yaml, context, configuration);
      }
      tmp = tmp_0;
    } else {
      if (node instanceof YamlScalar) {
        var tmp_3;
        var tmp_4;
        var tmp_5;
        var tmp_6 = descriptor.gx();
        if (tmp_6 instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          var tmp_7 = descriptor.gx();
          tmp_5 = tmp_7 instanceof ENUM;
        }
        if (tmp_5) {
          tmp_4 = true;
        } else {
          tmp_4 = descriptor.hx();
        }
        if (tmp_4) {
          tmp_3 = new YamlScalarInput(node, yaml, context, configuration);
        } else {
          var tmp_8 = descriptor.gx();
          if (tmp_8 instanceof CONTEXTUAL) {
            tmp_3 = createContextual(this, node, yaml, context, configuration, descriptor);
          } else {
            var tmp_9 = descriptor.gx();
            if (tmp_9 instanceof PolymorphicKind) {
              throw MissingTypeTagException.he4(node.cec_1);
            } else {
              throw IncorrectTypeException.ue4('Expected ' + get_friendlyDescription(descriptor.gx()) + ', but got a scalar value', node.cec_1);
            }
          }
        }
        tmp = tmp_3;
      } else {
        if (node instanceof YamlList) {
          var tmp2_subject = descriptor.gx();
          var tmp_10;
          if (tmp2_subject instanceof LIST) {
            tmp_10 = new YamlListInput(node, yaml, context, configuration);
          } else {
            if (tmp2_subject instanceof CONTEXTUAL) {
              tmp_10 = createContextual(this, node, yaml, context, configuration, descriptor);
            } else {
              throw IncorrectTypeException.ue4('Expected ' + get_friendlyDescription(descriptor.gx()) + ', but got a list', node.lec_1);
            }
          }
          tmp = tmp_10;
        } else {
          if (node instanceof YamlMap) {
            var tmp3_subject = descriptor.gx();
            var tmp_11;
            var tmp_12;
            if (tmp3_subject instanceof CLASS) {
              tmp_12 = true;
            } else {
              tmp_12 = equals(tmp3_subject, OBJECT_getInstance());
            }
            if (tmp_12) {
              tmp_11 = new YamlObjectInput(node, yaml, context, configuration);
            } else {
              if (tmp3_subject instanceof MAP) {
                tmp_11 = new YamlMapInput(node, yaml, context, configuration);
              } else {
                if (tmp3_subject instanceof CONTEXTUAL) {
                  tmp_11 = createContextual(this, node, yaml, context, configuration, descriptor);
                } else {
                  if (tmp3_subject instanceof PolymorphicKind) {
                    var tmp_13;
                    switch (configuration.re2_1.p3_1) {
                      case 2:
                        throw IncorrectTypeException.ue4("Encountered a polymorphic map descriptor but PolymorphismStyle is 'None'", node.iec_1);
                      case 0:
                        throw MissingTypeTagException.he4(node.iec_1);
                      case 1:
                        tmp_13 = createPolymorphicMapDeserializer(this, node, yaml, context, configuration);
                        break;
                      default:
                        noWhenBranchMatchedException();
                        break;
                    }
                    tmp_11 = tmp_13;
                  } else {
                    throw IncorrectTypeException.ue4('Expected ' + get_friendlyDescription(descriptor.gx()) + ', but got a map', node.iec_1);
                  }
                }
              }
            }
            tmp = tmp_11;
          } else {
            if (node instanceof YamlTaggedNode) {
              var tmp_14;
              var tmp_15;
              var tmp_16 = descriptor.gx();
              if (tmp_16 instanceof PolymorphicKind) {
                tmp_15 = configuration.re2_1.equals(PolymorphismStyle_None_getInstance());
              } else {
                tmp_15 = false;
              }
              if (tmp_15) {
                throw IncorrectTypeException.ue4("Encountered a tagged polymorphic descriptor but PolymorphismStyle is 'None'", node.d3e());
              } else {
                var tmp_17;
                var tmp_18 = descriptor.gx();
                if (tmp_18 instanceof PolymorphicKind) {
                  tmp_17 = configuration.re2_1.equals(PolymorphismStyle_Tag_getInstance());
                } else {
                  tmp_17 = false;
                }
                if (tmp_17) {
                  tmp_14 = new YamlPolymorphicInput(node.pec_1, node.d3e(), node.qec_1, yaml, context, configuration);
                } else {
                  tmp_14 = this.je2(node.qec_1, yaml, context, configuration, descriptor);
                }
              }
              tmp = tmp_14;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    return tmp;
  }
}
class YamlListInput extends YamlInput {
  constructor(list, yaml, context, configuration) {
    super(list, yaml, context, configuration);
    this.vec_1 = list;
    this.wec_1 = 0;
  }
  pz(descriptor) {
    return this.vec_1.kec_1.g1();
  }
  oz(descriptor) {
    if (this.wec_1 === this.vec_1.kec_1.g1()) {
      return -1;
    }
    this.xec_1 = Companion_getInstance_1().je2(this.vec_1.kec_1.h1(this.wec_1), this.le2_1, this.mz(), this.ne2_1, descriptor.ex(0));
    var _unary__edvuaz = this.wec_1;
    this.wec_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  iy() {
    if (!_get_haveStartedReadingElements__wj0go1(this)) {
      return true;
    }
    return _get_currentElementDecoder__u73r00(this).iy();
  }
  sy() {
    return _get_currentElementDecoder__u73r00(this).sy();
  }
  ny() {
    return _get_currentElementDecoder__u73r00(this).ny();
  }
  oy() {
    return _get_currentElementDecoder__u73r00(this).oy();
  }
  my() {
    return _get_currentElementDecoder__u73r00(this).my();
  }
  ly() {
    return _get_currentElementDecoder__u73r00(this).ly();
  }
  qy() {
    return _get_currentElementDecoder__u73r00(this).qy();
  }
  py() {
    return _get_currentElementDecoder__u73r00(this).py();
  }
  ky() {
    return _get_currentElementDecoder__u73r00(this).ky();
  }
  ry() {
    return _get_currentElementDecoder__u73r00(this).ry();
  }
  ty(enumDescriptor) {
    return _get_currentElementDecoder__u73r00(this).ty(enumDescriptor);
  }
  xy(descriptor) {
    if (_get_haveStartedReadingElements__wj0go1(this)) {
      return _get_currentElementDecoder__u73r00(this);
    }
    return super.xy(descriptor);
  }
}
class YamlMapLikeInputBase extends YamlInput {
  constructor(map, yaml, context, configuration) {
    super(map, yaml, context, configuration);
    this.oed_1 = false;
  }
  ted() {
    var tmp = this.med_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('currentValueDecoder');
    }
  }
  qed() {
    var tmp = this.ned_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('currentKey');
    }
  }
  iy() {
    if (!this.sed()) {
      return true;
    }
    return this.red(YamlMapLikeInputBase$decodeNotNullMark$lambda);
  }
  sy() {
    return this.red(YamlMapLikeInputBase$decodeString$lambda);
  }
  ny() {
    return this.red(YamlMapLikeInputBase$decodeInt$lambda);
  }
  oy() {
    return this.red(YamlMapLikeInputBase$decodeLong$lambda);
  }
  my() {
    return this.red(YamlMapLikeInputBase$decodeShort$lambda);
  }
  ly() {
    return this.red(YamlMapLikeInputBase$decodeByte$lambda);
  }
  qy() {
    return this.red(YamlMapLikeInputBase$decodeDouble$lambda);
  }
  py() {
    return this.red(YamlMapLikeInputBase$decodeFloat$lambda);
  }
  ky() {
    return this.red(YamlMapLikeInputBase$decodeBoolean$lambda);
  }
  ry() {
    return this.red(YamlMapLikeInputBase$decodeChar$lambda).n2_1;
  }
  ty(enumDescriptor) {
    return this.red(YamlMapLikeInputBase$decodeEnum$lambda(enumDescriptor));
  }
  red(action) {
    try {
      return action(this.ted());
    } catch ($p) {
      if ($p instanceof YamlException) {
        var e = $p;
        if (this.oed_1) {
          throw InvalidPropertyValueException.ve5(this.ped(), e.fe(), e.ae5_1, e);
        } else {
          throw e;
        }
      } else {
        throw $p;
      }
    }
  }
  sed() {
    return !(this.med_1 == null);
  }
  ped() {
    return this.qed().bec_1;
  }
}
class YamlMapInput extends YamlMapLikeInputBase {
  constructor(map, yaml, context, configuration) {
    super(map, yaml, context, configuration);
    this.fed_1 = toList(map.hec_1.u1());
    this.ged_1 = 0;
  }
  oz(descriptor) {
    if (this.ged_1 === imul(this.fed_1.g1(), 2)) {
      return -1;
    }
    var entryIndex = this.ged_1 / 2 | 0;
    this.hed_1 = this.fed_1.h1(entryIndex);
    this.ned_1 = _get_currentEntry__q2u5ma(this).v1();
    this.oed_1 = !((this.ged_1 % 2 | 0) === 0);
    var tmp = this;
    var tmp_0;
    switch (this.oed_1) {
      case true:
        var tmp_1;
        try {
          tmp_1 = Companion_getInstance_1().je2(_get_currentEntry__q2u5ma(this).w1(), this.le2_1, this.mz(), this.ne2_1, descriptor.ex(1));
        } catch ($p) {
          var tmp_2;
          if ($p instanceof IncorrectTypeException) {
            var e = $p;
            throw InvalidPropertyValueException.ve5(this.ped(), e.fe(), e.ae5_1, e);
          } else {
            throw $p;
          }
        }

        tmp_0 = tmp_1;
        break;
      case false:
        tmp_0 = Companion_getInstance_1().je2(this.qed(), this.le2_1, this.mz(), this.ne2_1, descriptor.ex(0));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.med_1 = tmp_0;
    var _unary__edvuaz = this.ged_1;
    this.ged_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  xy(descriptor) {
    if (this.sed()) {
      return this.red(YamlMapInput$beginStructure$lambda(descriptor));
    }
    return super.xy(descriptor);
  }
}
class YamlNode {
  constructor(path) {
    this.dec_1 = path;
  }
  d3e() {
    return this.dec_1;
  }
  ued() {
    return this.d3e().hea_1;
  }
  wed(child, newParentPath) {
    return YamlPath.xed(plus(newParentPath.gea_1, drop(child.d3e().gea_1, this.d3e().gea_1.g1())));
  }
}
class YamlNull extends YamlNode {
  constructor(path) {
    super(path);
    this.fec_1 = path;
  }
  d3e() {
    return this.fec_1;
  }
  ved(newPath) {
    return new YamlNull(newPath);
  }
  toString() {
    return 'null @ ' + this.fec_1.toString();
  }
  hashCode() {
    return this.fec_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlNull))
      return false;
    var tmp0_other_with_cast = other instanceof YamlNull ? other : THROW_CCE();
    if (!this.fec_1.equals(tmp0_other_with_cast.fec_1))
      return false;
    return true;
  }
}
class YamlScalar extends YamlNode {
  constructor(content, path) {
    super(path);
    this.bec_1 = content;
    this.cec_1 = path;
  }
  d3e() {
    return this.cec_1;
  }
  yed(other) {
    var tmp;
    if (other instanceof YamlScalar) {
      tmp = this.bec_1 === other.bec_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  zed() {
    return "'" + this.bec_1 + "'";
  }
  k4() {
    return convertToIntegerLikeValue(this, toByte$ref(), 'byte');
  }
  l4() {
    return convertToIntegerLikeValue(this, toShort$ref(), 'short');
  }
  l2() {
    return convertToIntegerLikeValue(this, toInt$ref(), 'integer');
  }
  d2() {
    return convertToIntegerLikeValue(this, toLong$ref(), 'long');
  }
  m4() {
    var tmp;
    switch (this.bec_1) {
      case '.inf':
      case '.Inf':
      case '.INF':
        tmp = Infinity;
        break;
      case '-.inf':
      case '-.Inf':
      case '-.INF':
        tmp = -Infinity;
        break;
      case '.nan':
      case '.NaN':
      case '.NAN':
        tmp = NaN;
        break;
      default:
        var tmp_0;
        try {
          // Inline function 'kotlin.text.toFloat' call
          var this_0 = this.bec_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = toDouble(this_0);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof NumberFormatException) {
            var e = $p;
            throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid floating point value.", this.cec_1, this.bec_1);
          } else {
            if ($p instanceof IndexOutOfBoundsException) {
              var e_0 = $p;
              throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid floating point value.", this.cec_1, this.bec_1);
            } else {
              throw $p;
            }
          }
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  n4() {
    var tmp;
    switch (this.bec_1) {
      case '.inf':
      case '.Inf':
      case '.INF':
        tmp = Infinity;
        break;
      case '-.inf':
      case '-.Inf':
      case '-.INF':
        tmp = -Infinity;
        break;
      case '.nan':
      case '.NaN':
      case '.NAN':
        tmp = NaN;
        break;
      default:
        var tmp_0;
        try {
          tmp_0 = toDouble(this.bec_1);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof NumberFormatException) {
            var e = $p;
            throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid floating point value.", this.cec_1, this.bec_1);
          } else {
            if ($p instanceof IndexOutOfBoundsException) {
              var e_0 = $p;
              throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid floating point value.", this.cec_1, this.bec_1);
            } else {
              throw $p;
            }
          }
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  }
  aee() {
    var tmp;
    switch (this.bec_1) {
      case 'true':
      case 'True':
      case 'TRUE':
        tmp = true;
        break;
      case 'false':
      case 'False':
      case 'FALSE':
        tmp = false;
        break;
      default:
        throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid boolean, permitted choices are: true or false", this.cec_1, this.bec_1);
    }
    return tmp;
  }
  bee() {
    var tmp0_elvis_lhs = singleOrNull(this.bec_1);
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
      throw YamlScalarFormatException.ne9("Value '" + this.bec_1 + "' is not a valid character value.", this.cec_1, this.bec_1);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  ved(newPath) {
    return this.cee(VOID, newPath);
  }
  toString() {
    return 'scalar @ ' + this.cec_1.toString() + ' : ' + this.bec_1;
  }
  dee(content, path) {
    return new YamlScalar(content, path);
  }
  cee(content, path, $super) {
    content = content === VOID ? this.bec_1 : content;
    path = path === VOID ? this.cec_1 : path;
    return $super === VOID ? this.dee(content, path) : $super.dee.call(this, content, path);
  }
  hashCode() {
    var result = getStringHashCode(this.bec_1);
    result = imul(result, 31) + this.cec_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlScalar))
      return false;
    var tmp0_other_with_cast = other instanceof YamlScalar ? other : THROW_CCE();
    if (!(this.bec_1 === tmp0_other_with_cast.bec_1))
      return false;
    if (!this.cec_1.equals(tmp0_other_with_cast.cec_1))
      return false;
    return true;
  }
}
class YamlList extends YamlNode {
  constructor(items, path) {
    super(path);
    this.kec_1 = items;
    this.lec_1 = path;
  }
  d3e() {
    return this.lec_1;
  }
  ved(newPath) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.kec_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'com.charleskorn.kaml.YamlList.withPath.<anonymous>' call
      var tmp$ret$0 = item.ved(this.wed(item, newPath));
      destination.h(tmp$ret$0);
    }
    var updatedItems = destination;
    return new YamlList(updatedItems, newPath);
  }
  toString() {
    var builder = StringBuilder.f();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'list @ ' + this.lec_1.toString() + ' (size: ' + this.kec_1.g1() + ')';
    // Inline function 'kotlin.text.appendLine' call
    builder.gc(value).hc(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = this.kec_1.b1();
    while (tmp0_iterator.c1()) {
      var item = tmp0_iterator.d1();
      // Inline function 'com.charleskorn.kaml.YamlList.toString.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      // Inline function 'kotlin.text.appendLine' call
      var value_0 = '- item ' + checkIndexOverflow(tmp1) + ':';
      // Inline function 'kotlin.text.appendLine' call
      builder.gc(value_0).hc(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = lines(toString(item)).b1();
      while (tmp0_iterator_0.c1()) {
        var element = tmp0_iterator_0.d1();
        // Inline function 'com.charleskorn.kaml.YamlList.toString.<anonymous>.<anonymous>' call
        builder.gc('  ');
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        builder.gc(element).hc(_Char___init__impl__6a9atx(10));
      }
    }
    return toString(trimEnd(builder));
  }
  hashCode() {
    var result = hashCode(this.kec_1);
    result = imul(result, 31) + this.lec_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlList))
      return false;
    var tmp0_other_with_cast = other instanceof YamlList ? other : THROW_CCE();
    if (!equals(this.kec_1, tmp0_other_with_cast.kec_1))
      return false;
    if (!this.lec_1.equals(tmp0_other_with_cast.lec_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.eee_1 = function_0;
  }
  vj(a, b) {
    return this.eee_1(a, b);
  }
  compare(a, b) {
    return this.vj(a, b);
  }
  o4() {
    return this.eee_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.o4(), other.o4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.o4());
  }
}
class YamlMap extends YamlNode {
  constructor(entries, path) {
    super(path);
    this.hec_1 = entries;
    this.iec_1 = path;
    var tmp = this.hec_1.f3();
    var tmp_0 = YamlMap$lambda;
    var keys = sortedWith(tmp, new sam$kotlin_Comparator$0(tmp_0));
    // Inline function 'kotlin.collections.mutableMapOf' call
    var encounteredKeys = LinkedHashMap.wc();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = keys.b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.charleskorn.kaml.YamlMap.<anonymous>' call
      var duplicate = encounteredKeys.e3(element.bec_1);
      if (!(duplicate == null)) {
        throw DuplicateKeyException.fea(duplicate.cec_1, element.cec_1, element.zed());
      }
      // Inline function 'kotlin.collections.set' call
      var key = element.bec_1;
      encounteredKeys.k3(key, element);
    }
  }
  d3e() {
    return this.iec_1;
  }
  mec(key) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.hec_1.u1().b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'com.charleskorn.kaml.YamlMap.get.<anonymous>' call
        if (element.v1().bec_1 === key) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp12_safe_receiver = tmp$ret$1;
    var tmp = tmp12_safe_receiver == null ? null : tmp12_safe_receiver.w1();
    return (tmp == null ? true : tmp instanceof YamlNode) ? tmp : THROW_CCE();
  }
  ved(newPath) {
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapKeys' call
    var this_0 = this.hec_1;
    // Inline function 'kotlin.collections.mapKeysTo' call
    var destination = LinkedHashMap.xc(mapCapacity(this_0.g1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator = this_0.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.charleskorn.kaml.YamlMap.withPath.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.v1();
      var tmp = k.ved(this.wed(k, newPath));
      // Inline function 'kotlin.collections.mapKeysTo.<anonymous>' call
      var tmp$ret$2 = element.w1();
      destination.k3(tmp, tmp$ret$2);
    }
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap.xc(mapCapacity(destination.g1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator_0 = destination.u1().b1();
    while (tmp0_iterator_0.c1()) {
      var element_0 = tmp0_iterator_0.d1();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_0 = element_0.v1();
      // Inline function 'com.charleskorn.kaml.YamlMap.withPath.<anonymous>' call
      // Inline function 'kotlin.collections.component2' call
      var v = element_0.w1();
      var tmp$ret$8 = v.ved(this.wed(v, newPath));
      destination_0.k3(tmp_0, tmp$ret$8);
    }
    var updatedEntries = destination_0;
    return new YamlMap(updatedEntries, newPath);
  }
  toString() {
    var builder = StringBuilder.f();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'map @ ' + this.iec_1.toString() + ' (size: ' + this.hec_1.g1() + ')';
    // Inline function 'kotlin.text.appendLine' call
    builder.gc(value).hc(_Char___init__impl__6a9atx(10));
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.hec_1.u1().b1();
    while (tmp0_iterator.c1()) {
      var element = tmp0_iterator.d1();
      // Inline function 'com.charleskorn.kaml.YamlMap.toString.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.v1();
      // Inline function 'kotlin.collections.component2' call
      var value_0 = element.w1();
      // Inline function 'kotlin.text.appendLine' call
      // Inline function 'kotlin.text.appendLine' call
      builder.gc('- key:').hc(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = lines(key.toString()).b1();
      while (tmp0_iterator_0.c1()) {
        var element_0 = tmp0_iterator_0.d1();
        // Inline function 'com.charleskorn.kaml.YamlMap.toString.<anonymous>.<anonymous>' call
        builder.gc('    ');
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        builder.gc(element_0).hc(_Char___init__impl__6a9atx(10));
      }
      // Inline function 'kotlin.text.appendLine' call
      var value_1 = '  value:';
      // Inline function 'kotlin.text.appendLine' call
      builder.gc(value_1).hc(_Char___init__impl__6a9atx(10));
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_1 = lines(toString(value_0)).b1();
      while (tmp0_iterator_1.c1()) {
        var element_1 = tmp0_iterator_1.d1();
        // Inline function 'com.charleskorn.kaml.YamlMap.toString.<anonymous>.<anonymous>' call
        builder.gc('    ');
        // Inline function 'kotlin.text.appendLine' call
        // Inline function 'kotlin.text.appendLine' call
        builder.gc(element_1).hc(_Char___init__impl__6a9atx(10));
      }
    }
    return toString(trimEnd(builder));
  }
  fee(entries, path) {
    return new YamlMap(entries, path);
  }
  nec(entries, path, $super) {
    entries = entries === VOID ? this.hec_1 : entries;
    path = path === VOID ? this.iec_1 : path;
    return $super === VOID ? this.fee(entries, path) : $super.fee.call(this, entries, path);
  }
  hashCode() {
    var result = hashCode(this.hec_1);
    result = imul(result, 31) + this.iec_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlMap))
      return false;
    var tmp0_other_with_cast = other instanceof YamlMap ? other : THROW_CCE();
    if (!equals(this.hec_1, tmp0_other_with_cast.hec_1))
      return false;
    if (!this.iec_1.equals(tmp0_other_with_cast.iec_1))
      return false;
    return true;
  }
}
class YamlTaggedNode extends YamlNode {
  constructor(tag, innerNode) {
    super(innerNode.d3e());
    this.pec_1 = tag;
    this.qec_1 = innerNode;
  }
  ved(newPath) {
    return this.gee(VOID, this.qec_1.ved(newPath));
  }
  toString() {
    return "tagged '" + this.pec_1 + "': " + toString(this.qec_1);
  }
  hee(tag, innerNode) {
    return new YamlTaggedNode(tag, innerNode);
  }
  gee(tag, innerNode, $super) {
    tag = tag === VOID ? this.pec_1 : tag;
    innerNode = innerNode === VOID ? this.qec_1 : innerNode;
    return $super === VOID ? this.hee(tag, innerNode) : $super.hee.call(this, tag, innerNode);
  }
  hashCode() {
    var result = getStringHashCode(this.pec_1);
    result = imul(result, 31) + hashCode(this.qec_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlTaggedNode))
      return false;
    var tmp0_other_with_cast = other instanceof YamlTaggedNode ? other : THROW_CCE();
    if (!(this.pec_1 === tmp0_other_with_cast.pec_1))
      return false;
    if (!equals(this.qec_1, tmp0_other_with_cast.qec_1))
      return false;
    return true;
  }
}
class YamlNodeReader {
  constructor(parser, extensionDefinitionPrefix, allowAnchorsAndAliases) {
    extensionDefinitionPrefix = extensionDefinitionPrefix === VOID ? null : extensionDefinitionPrefix;
    allowAnchorsAndAliases = allowAnchorsAndAliases === VOID ? false : allowAnchorsAndAliases;
    this.de3_1 = parser;
    this.ee3_1 = extensionDefinitionPrefix;
    this.fe3_1 = allowAnchorsAndAliases;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.ge3_1 = LinkedHashMap.wc();
  }
  y1n() {
    return readNode(this, Companion_getInstance_3().jee_1);
  }
}
class YamlNullInput extends YamlInput {
  constructor(nullValue, yaml, context, configuration) {
    super(nullValue, yaml, context, configuration);
    this.yee_1 = nullValue;
  }
  iy() {
    return false;
  }
  hy() {
    throw UnexpectedNullValueException.uea(this.yee_1.d3e());
  }
  pz(descriptor) {
    throw UnexpectedNullValueException.uea(this.yee_1.d3e());
  }
  xy(descriptor) {
    throw UnexpectedNullValueException.uea(this.yee_1.d3e());
  }
  oz(descriptor) {
    return -1;
  }
}
class YamlObjectInput extends YamlMapLikeInputBase {
  constructor(map, yaml, context, configuration) {
    super(map, yaml, context, configuration);
    this.gef_1 = toList(map.hec_1.u1());
    this.hef_1 = 0;
  }
  oz(descriptor) {
    if (!!(this.ief_1 == null)) {
      var tmp = this;
      // Inline function 'kotlin.collections.associateBy' call
      var this_0 = until(0, descriptor.ix());
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateByTo' call
      var destination = LinkedHashMap.xc(capacity);
      var inductionVariable = this_0.f2_1;
      var last = this_0.g2_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.charleskorn.kaml.YamlObjectInput.decodeElementIndex.<anonymous>' call
          var index = element;
          var elementName = descriptor.bx(index);
          var tmp21_safe_receiver = this.ne2_1.be3_1;
          var tmp0_elvis_lhs = tmp21_safe_receiver == null ? null : tmp21_safe_receiver.jef(elementName);
          var tmp$ret$0 = tmp0_elvis_lhs == null ? elementName : tmp0_elvis_lhs;
          destination.k3(tmp$ret$0, element);
        }
         while (!(element === last));
      tmp.ief_1 = destination;
    }
    $l$loop: while (true) {
      if (this.hef_1 === this.gef_1.g1()) {
        return -1;
      }
      var currentEntry = this.gef_1.h1(this.hef_1);
      this.ned_1 = currentEntry.v1();
      var tmp0_elvis_lhs_0 = _get_pairedPropertyNames__11quvr(this).e3(this.ped());
      var fieldDescriptorIndex = tmp0_elvis_lhs_0 == null ? -3 : tmp0_elvis_lhs_0;
      if (fieldDescriptorIndex === -3) {
        if (this.ne2_1.pe2_1) {
          throw UnknownPropertyException.keb(this.ped(), _get_pairedPropertyNames__11quvr(this).f3(), this.qed().cec_1);
        } else {
          this.hef_1 = this.hef_1 + 1 | 0;
          continue $l$loop;
        }
      }
      try {
        this.med_1 = Companion_getInstance_1().je2(this.gef_1.h1(this.hef_1).w1(), this.le2_1, this.mz(), this.ne2_1, descriptor.ex(fieldDescriptorIndex));
      } catch ($p) {
        if ($p instanceof IncorrectTypeException) {
          var e = $p;
          throw InvalidPropertyValueException.ve5(this.ped(), e.fe(), e.ae5_1, e);
        } else {
          throw $p;
        }
      }
      this.oed_1 = true;
      this.hef_1 = this.hef_1 + 1 | 0;
      return fieldDescriptorIndex;
    }
  }
  xy(descriptor) {
    if (this.sed()) {
      return this.red(YamlObjectInput$beginStructure$lambda(descriptor));
    }
    return super.xy(descriptor);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_3 = this;
    this.lef_1 = new ImplicitTuple(true, true);
    this.mef_1 = new ImplicitTuple(false, false);
  }
}
class YamlOutput extends AbstractEncoder {
  static fe2(writer, serializersModule, configuration) {
    Companion_getInstance_2();
    var $this = this.qz();
    $this.ze1_1 = serializersModule;
    $this.ae2_1 = configuration;
    $this.be2_1 = Companion_instance.w11().hdi(true).qdh($this.ae2_1.te2_1).edi($this.ae2_1.ze2_1).gdi($this.ae2_1.ze2_1 > 0).fdi($this.ae2_1.ue2_1).idi();
    $this.ce2_1 = new Emitter($this.be2_1, writer);
    $this.de2_1 = false;
    $this.ee2_1 = null;
    $this.ce2_1.pdq(StreamStartEvent.lds());
    $this.ce2_1.pdq(DocumentStartEvent.edr(false, null, emptyMap()));
    return $this;
  }
  mz() {
    return this.ze1_1;
  }
  v10(descriptor, index) {
    return this.ae2_1.oe2_1;
  }
  tz() {
    return emitPlainScalar(this, 'null');
  }
  uz(value) {
    return emitPlainScalar(this, value.toString());
  }
  vz(value) {
    return emitPlainScalar(this, value.toString());
  }
  b10(value) {
    return emitQuotedScalar(this, toString_1(value), _get_scalarStyle__245jbg_0(this.ae2_1.we2_1, this));
  }
  a10(value) {
    return emitPlainScalar(this, value.toString());
  }
  zz(value) {
    return emitPlainScalar(this, value.toString());
  }
  xz(value) {
    return emitPlainScalar(this, value.toString());
  }
  yz(value) {
    return emitPlainScalar(this, value.toString());
  }
  wz(value) {
    return emitPlainScalar(this, value.toString());
  }
  c10(value) {
    if (this.de2_1) {
      this.ee2_1 = value;
      this.de2_1 = false;
    } else {
      if (contains(value, _Char___init__impl__6a9atx(10))) {
        emitQuotedScalar(this, value, _get_scalarStyle__245jbg(this.ae2_1.xe2_1, this));
      } else if (this.ae2_1.we2_1.equals(SingleLineStringStyle_PlainExceptAmbiguous_getInstance()) && isAmbiguous(value, this)) {
        emitQuotedScalar(this, value, _get_scalarStyle__245jbg_1(this.ae2_1.ye2_1, this));
      } else {
        emitQuotedScalar(this, value, _get_scalarStyle__245jbg_0(this.ae2_1.we2_1, this));
      }
    }
  }
  d10(enumDescriptor, index) {
    return emitQuotedScalar(this, enumDescriptor.bx(index), _get_scalarStyle__245jbg_0(this.ae2_1.we2_1, this));
  }
  rz(descriptor, index) {
    encodeComment(this, descriptor, index);
    var tmp = descriptor.gx();
    if (tmp instanceof CLASS) {
      var elementName = descriptor.bx(index);
      var tmp22_safe_receiver = this.ae2_1.be3_1;
      var tmp0_elvis_lhs = tmp22_safe_receiver == null ? null : tmp22_safe_receiver.jef(elementName);
      var serializedName = tmp0_elvis_lhs == null ? elementName : tmp0_elvis_lhs;
      emitPlainScalar(this, serializedName);
    }
    return super.rz(descriptor, index);
  }
  xy(descriptor) {
    var tmp23_subject = descriptor.gx();
    if (tmp23_subject instanceof PolymorphicKind)
      this.de2_1 = true;
    else {
      if (equals(tmp23_subject, LIST_getInstance())) {
        this.ce2_1.pdq(SequenceStartEvent.dds(null, null, true, _get_flowStyle__eylgtu(this.ae2_1.ve2_1, this)));
      } else {
        if (equals(tmp23_subject, MAP_getInstance()) || (equals(tmp23_subject, CLASS_getInstance()) || equals(tmp23_subject, OBJECT_getInstance()))) {
          var typeName = getAndClearTypeName(this);
          switch (this.ae2_1.re2_1.p3_1) {
            case 0:
              var implicit = typeName == null;
              this.ce2_1.pdq(MappingStartEvent.qdr(null, typeName, implicit, FlowStyle_BLOCK_getInstance()));
              break;
            case 1:
              this.ce2_1.pdq(MappingStartEvent.qdr(null, null, true, FlowStyle_BLOCK_getInstance()));
              if (!(typeName == null)) {
                emitPlainScalar(this, this.ae2_1.se2_1);
                emitQuotedScalar(this, typeName, _get_scalarStyle__245jbg_0(SingleLineStringStyle_DoubleQuoted_getInstance(), this));
              }

              break;
            case 2:
              this.ce2_1.pdq(MappingStartEvent.qdr(null, null, true, FlowStyle_BLOCK_getInstance()));
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
        }
      }
    }
    return super.xy(descriptor);
  }
  yy(descriptor) {
    var tmp25_subject = descriptor.gx();
    if (equals(tmp25_subject, LIST_getInstance())) {
      this.ce2_1.pdq(SequenceEndEvent.wdr());
    } else if (equals(tmp25_subject, MAP_getInstance()) || (equals(tmp25_subject, CLASS_getInstance()) || equals(tmp25_subject, OBJECT_getInstance()))) {
      this.ce2_1.pdq(MappingEndEvent.jdr());
    }
  }
  p6() {
    this.ce2_1.pdq(DocumentEndEvent.ddr(false));
    this.ce2_1.pdq(StreamEndEvent.hds());
  }
}
class YamlParser {
  constructor(reader, codePointLimit) {
    codePointLimit = codePointLimit === VOID ? null : codePointLimit;
    this.he3_1 = 'DUMMY_FILE_NAME';
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = Companion_instance_0.w11();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.charleskorn.kaml.YamlParser.loadSettings.<anonymous>' call
    if (!(codePointLimit == null)) {
      this_0.cdk(codePointLimit);
    }
    this_0.bdk(this.he3_1);
    tmp.ie3_1 = this_0.idi();
    this.je3_1 = new StreamReader(this.ie3_1, reader);
    this.ke3_1 = ParserImpl.zdx(this.ie3_1, this.je3_1);
    this.oee(ID_StreamStart_getInstance(), Companion_getInstance_3().jee_1);
    if (this.mee(Companion_getInstance_3().jee_1).gdk().equals(ID_StreamEnd_getInstance())) {
      throw EmptyYamlDocumentException.we6('The YAML document is empty.', Companion_getInstance_3().jee_1);
    }
    this.oee(ID_DocumentStart_getInstance(), Companion_getInstance_3().jee_1);
  }
  le3() {
    this.oee(ID_DocumentEnd_getInstance(), Companion_getInstance_3().jee_1);
    this.oee(ID_StreamEnd_getInstance(), Companion_getInstance_3().jee_1);
  }
  iee(path) {
    return checkEvent(this, path, YamlParser$consumeEvent$lambda(this));
  }
  mee(path) {
    return checkEvent(this, path, YamlParser$peekEvent$lambda(this));
  }
  oee(type, path) {
    var event = this.iee(path);
    if (!event.gdk().equals(type)) {
      throw MalformedYamlException.je7('Unexpected ' + event.gdk().toString() + ', expected ' + type.toString(), path.lee(new Location(ensureNotNull(event.edk_1).pds_1, ensureNotNull(event.edk_1).qds_1)));
    }
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_4 = this;
    this.jee_1 = YamlPath.nef([Root_getInstance()]);
  }
  kee(name, location) {
    return YamlPath.nef([new AliasDefinition(name, location)]);
  }
}
class YamlPath {
  static xed(segments) {
    Companion_getInstance_3();
    var $this = createThis(this);
    $this.gea_1 = segments;
    if ($this.gea_1.j1()) {
      throw IllegalArgumentException.l('Path must contain at least one segment.');
    }
    var tmp;
    var tmp_0 = first($this.gea_1);
    if (!(tmp_0 instanceof Root)) {
      var tmp_1 = first($this.gea_1);
      tmp = !(tmp_1 instanceof AliasDefinition);
    } else {
      tmp = false;
    }
    if (tmp) {
      throw IllegalArgumentException.l('First element of path must be root segment or alias definition.');
    }
    if (drop($this.gea_1, 1).z2(Root_getInstance())) {
      throw IllegalArgumentException.l('Root segment can only be first element of path.');
    }
    $this.hea_1 = last($this.gea_1).ued();
    return $this;
  }
  static nef(segments) {
    Companion_getInstance_3();
    return this.xed(toList_0(segments));
  }
  lee(location) {
    return withSegment(this, new Error_0(location));
  }
  nee(index, location) {
    return withSegment(this, new ListEntry(index, location));
  }
  pee(key, location) {
    return withSegment(this, new MapElementKey(key, location));
  }
  qee(location) {
    return withSegment(this, new MapElementValue(location));
  }
  see(name, location) {
    return withSegment(this, new AliasReference(name, location));
  }
  tee(name, location) {
    return withSegment(this, new AliasDefinition(name, location));
  }
  ree(location) {
    return withSegment(this, new Merge(location));
  }
  vea() {
    var builder = StringBuilder.f();
    var nextSegmentIndex = 1;
    while (nextSegmentIndex <= get_lastIndex(this.gea_1)) {
      var segmentIndex = nextSegmentIndex;
      nextSegmentIndex = nextSegmentIndex + 1 | 0;
      var segment = this.gea_1.h1(segmentIndex);
      if (segment instanceof ListEntry) {
        builder.hc(_Char___init__impl__6a9atx(91));
        builder.rh(segment.qef_1);
        builder.hc(_Char___init__impl__6a9atx(93));
      } else {
        if (segment instanceof MapElementKey) {
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(builder) > 0) {
            builder.hc(_Char___init__impl__6a9atx(46));
          }
          builder.gc(segment.wef_1);
        } else {
          if (segment instanceof AliasReference) {
            builder.gc('->&');
            builder.gc(segment.tef_1);
          } else {
            if (segment instanceof Merge) {
              builder.gc('>>(merged');
              var tmp;
              if (nextSegmentIndex <= get_lastIndex(this.gea_1)) {
                var tmp_0 = this.gea_1.h1(nextSegmentIndex);
                tmp = tmp_0 instanceof ListEntry;
              } else {
                tmp = false;
              }
              if (tmp) {
                builder.gc(' entry ');
                var tmp_1 = this.gea_1.h1(nextSegmentIndex);
                builder.rh((tmp_1 instanceof ListEntry ? tmp_1 : THROW_CCE()).qef_1);
                nextSegmentIndex = nextSegmentIndex + 1 | 0;
              }
              var tmp_2;
              if (nextSegmentIndex <= get_lastIndex(this.gea_1)) {
                var tmp_3 = this.gea_1.h1(nextSegmentIndex);
                tmp_2 = tmp_3 instanceof AliasReference;
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                builder.gc(' &');
                var tmp_4 = this.gea_1.h1(nextSegmentIndex);
                builder.gc((tmp_4 instanceof AliasReference ? tmp_4 : THROW_CCE()).tef_1);
                nextSegmentIndex = nextSegmentIndex + 1 | 0;
              }
              builder.gc(')');
            } else {
              var tmp_5;
              var tmp_6;
              if (segment instanceof Root) {
                tmp_6 = true;
              } else {
                tmp_6 = segment instanceof Error_0;
              }
              if (tmp_6) {
                tmp_5 = true;
              } else {
                var tmp_7;
                if (segment instanceof MapElementValue) {
                  tmp_7 = true;
                } else {
                  tmp_7 = segment instanceof AliasDefinition;
                }
                tmp_5 = tmp_7;
              }
              if (!tmp_5) {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(builder) > 0) {
      return builder.toString();
    }
    return '<root>';
  }
  toString() {
    return 'YamlPath(segments=' + toString(this.gea_1) + ')';
  }
  hashCode() {
    return hashCode(this.gea_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof YamlPath))
      return false;
    var tmp0_other_with_cast = other instanceof YamlPath ? other : THROW_CCE();
    if (!equals(this.gea_1, tmp0_other_with_cast.gea_1))
      return false;
    return true;
  }
}
class YamlPathSegment {
  constructor(location) {
    this.oef_1 = location;
  }
  ued() {
    return this.oef_1;
  }
}
class Root extends YamlPathSegment {
  constructor() {
    Root_instance = null;
    super(new Location(1, 1));
    Root_instance = this;
  }
}
class ListEntry extends YamlPathSegment {
  constructor(index, location) {
    super(location);
    this.qef_1 = index;
    this.ref_1 = location;
  }
  ued() {
    return this.ref_1;
  }
  toString() {
    return 'ListEntry(index=' + this.qef_1 + ', location=' + this.ref_1.toString() + ')';
  }
  hashCode() {
    var result = this.qef_1;
    result = imul(result, 31) + this.ref_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ListEntry))
      return false;
    var tmp0_other_with_cast = other instanceof ListEntry ? other : THROW_CCE();
    if (!(this.qef_1 === tmp0_other_with_cast.qef_1))
      return false;
    if (!this.ref_1.equals(tmp0_other_with_cast.ref_1))
      return false;
    return true;
  }
}
class MapElementKey extends YamlPathSegment {
  constructor(key, location) {
    super(location);
    this.wef_1 = key;
    this.xef_1 = location;
  }
  ued() {
    return this.xef_1;
  }
  toString() {
    return 'MapElementKey(key=' + this.wef_1 + ', location=' + this.xef_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.wef_1);
    result = imul(result, 31) + this.xef_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapElementKey))
      return false;
    var tmp0_other_with_cast = other instanceof MapElementKey ? other : THROW_CCE();
    if (!(this.wef_1 === tmp0_other_with_cast.wef_1))
      return false;
    if (!this.xef_1.equals(tmp0_other_with_cast.xef_1))
      return false;
    return true;
  }
}
class MapElementValue extends YamlPathSegment {
  constructor(location) {
    super(location);
    this.zef_1 = location;
  }
  ued() {
    return this.zef_1;
  }
  toString() {
    return 'MapElementValue(location=' + this.zef_1.toString() + ')';
  }
  hashCode() {
    return this.zef_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapElementValue))
      return false;
    var tmp0_other_with_cast = other instanceof MapElementValue ? other : THROW_CCE();
    if (!this.zef_1.equals(tmp0_other_with_cast.zef_1))
      return false;
    return true;
  }
}
class AliasReference extends YamlPathSegment {
  constructor(name, location) {
    super(location);
    this.tef_1 = name;
    this.uef_1 = location;
  }
  ued() {
    return this.uef_1;
  }
  toString() {
    return 'AliasReference(name=' + this.tef_1 + ', location=' + this.uef_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.tef_1);
    result = imul(result, 31) + this.uef_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AliasReference))
      return false;
    var tmp0_other_with_cast = other instanceof AliasReference ? other : THROW_CCE();
    if (!(this.tef_1 === tmp0_other_with_cast.tef_1))
      return false;
    if (!this.uef_1.equals(tmp0_other_with_cast.uef_1))
      return false;
    return true;
  }
}
class AliasDefinition extends YamlPathSegment {
  constructor(name, location) {
    super(location);
    this.beg_1 = name;
    this.ceg_1 = location;
  }
  ued() {
    return this.ceg_1;
  }
  toString() {
    return 'AliasDefinition(name=' + this.beg_1 + ', location=' + this.ceg_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.beg_1);
    result = imul(result, 31) + this.ceg_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AliasDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof AliasDefinition ? other : THROW_CCE();
    if (!(this.beg_1 === tmp0_other_with_cast.beg_1))
      return false;
    if (!this.ceg_1.equals(tmp0_other_with_cast.ceg_1))
      return false;
    return true;
  }
}
class Merge extends YamlPathSegment {
  constructor(location) {
    super(location);
    this.eeg_1 = location;
  }
  ued() {
    return this.eeg_1;
  }
  toString() {
    return 'Merge(location=' + this.eeg_1.toString() + ')';
  }
  hashCode() {
    return this.eeg_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Merge))
      return false;
    var tmp0_other_with_cast = other instanceof Merge ? other : THROW_CCE();
    if (!this.eeg_1.equals(tmp0_other_with_cast.eeg_1))
      return false;
    return true;
  }
}
class Error_0 extends YamlPathSegment {
  constructor(location) {
    super(location);
    this.geg_1 = location;
  }
  ued() {
    return this.geg_1;
  }
  toString() {
    return 'Error(location=' + this.geg_1.toString() + ')';
  }
  hashCode() {
    return this.geg_1.hashCode();
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Error_0))
      return false;
    var tmp0_other_with_cast = other instanceof Error_0 ? other : THROW_CCE();
    if (!this.geg_1.equals(tmp0_other_with_cast.geg_1))
      return false;
    return true;
  }
}
class CurrentField extends Enum {}
class Companion_3 {
  constructor() {
    Companion_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.text.toRegex' call
    var this_0 = "^Serializer for subclass '(.*)' is not found in the polymorphic scope of '(.*)'.\\n.*";
    tmp.qeg_1 = Regex.pi(this_0);
  }
}
class YamlPolymorphicInput$getKnownTypesForOpenType$1 {
  constructor($className, $knownTypes) {
    this.reg_1 = $className;
    this.seg_1 = $knownTypes;
  }
  j1g(kClass, provider) {
  }
  m1g(baseClass, actualClass, actualSerializer) {
    if (baseClass.yf() === this.reg_1) {
      this.seg_1.h(actualSerializer.yu().ax());
    }
  }
  n1g(baseClass, defaultSerializerProvider) {
    throw UnsupportedOperationException.sa('This method should never be called.');
  }
  o1g(baseClass, defaultDeserializerProvider) {
    throw UnsupportedOperationException.sa('This method should never be called');
  }
}
class YamlPolymorphicInput extends YamlInput {
  constructor(typeName, typeNamePath, contentNode, yaml, context, configuration) {
    Companion_getInstance_4();
    super(contentNode, yaml, context, configuration);
    this.leg_1 = typeName;
    this.meg_1 = typeNamePath;
    this.neg_1 = contentNode;
    this.oeg_1 = CurrentField_NotStarted_getInstance();
  }
  oz(descriptor) {
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
        this.oeg_1 = CurrentField_Type_getInstance();
        tmp = 0;
        break;
      case 1:
        var tmp32_subject = this.neg_1;
        if (tmp32_subject instanceof YamlScalar)
          this.peg_1 = new YamlScalarInput(this.neg_1, this.le2_1, this.mz(), this.ne2_1);
        else {
          if (tmp32_subject instanceof YamlNull)
            this.peg_1 = new YamlNullInput(this.neg_1, this.le2_1, this.mz(), this.ne2_1);
        }

        this.oeg_1 = CurrentField_Content_getInstance();
        tmp = 1;
        break;
      case 2:
        tmp = -1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  iy() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.decodeNotNullMark.<anonymous>' call

        tmp = true;
        break;
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).iy();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  jy() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeNull';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).jy();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ky() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeBoolean';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).ky();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ly() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeByte';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).ly();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  my() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeShort';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).my();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ny() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeInt';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).ny();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  oy() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeLong';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).oy();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  py() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeFloat';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).py();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  qy() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeDouble';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).qy();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ry() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeChar';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        var tmp$ret$0 = _get_contentDecoder__ypxfj4(this).ry();
        tmp = new Char(tmp$ret$0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp.n2_1;
  }
  sy() {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.decodeString.<anonymous>' call

        tmp = this.leg_1;
        break;
      case 2:
        tmp = _get_contentDecoder__ypxfj4(this).sy();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  ty(enumDescriptor) {
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var functionName = 'decodeEnum';
    // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.maybeCallOnContent' call
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        throw UnsupportedOperationException.sa("Can't call " + functionName + '() on type field');
      case 2:
        // Inline function 'com.charleskorn.kaml.YamlPolymorphicInput.decodeEnum.<anonymous>' call

        tmp = _get_contentDecoder__ypxfj4(this).ty(enumDescriptor);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  xy(descriptor) {
    var tmp;
    switch (this.oeg_1.p3_1) {
      case 0:
      case 1:
        tmp = super.xy(descriptor);
        break;
      case 2:
        this.peg_1 = Companion_getInstance_1().je2(this.neg_1, this.le2_1, this.mz(), this.ne2_1, descriptor);
        return _get_contentDecoder__ypxfj4(this);
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  wy(deserializer) {
    try {
      return super.wy(deserializer);
    } catch ($p) {
      if ($p instanceof SerializationException) {
        var e = $p;
        throwIfUnknownPolymorphicTypeException(this, e, deserializer);
        throw e;
      } else {
        throw $p;
      }
    }
  }
}
class YamlScalarInput extends YamlInput {
  constructor(scalar, yaml, context, configuration) {
    super(scalar, yaml, context, configuration);
    this.xeg_1 = scalar;
  }
  sy() {
    return this.xeg_1.bec_1;
  }
  ny() {
    return this.xeg_1.l2();
  }
  oy() {
    return this.xeg_1.d2();
  }
  my() {
    return this.xeg_1.l4();
  }
  ly() {
    return this.xeg_1.k4();
  }
  qy() {
    return this.xeg_1.n4();
  }
  py() {
    return this.xeg_1.m4();
  }
  ky() {
    return this.xeg_1.aee();
  }
  ry() {
    return this.xeg_1.bee();
  }
  ty(enumDescriptor) {
    var index = enumDescriptor.cx(this.xeg_1.bec_1);
    if (!(index === -3)) {
      return index;
    }
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(0, enumDescriptor.ix() - 1 | 0);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.f2_1;
    var last = this_0.g2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.charleskorn.kaml.YamlScalarInput.decodeEnum.<anonymous>' call
        var it = item;
        var tmp$ret$0 = enumDescriptor.bx(it);
        destination.h(tmp$ret$0);
      }
       while (!(item === last));
    var choices = joinToString(sorted(destination), ', ');
    throw YamlScalarFormatException.ne9('Value ' + this.xeg_1.zed() + ' is not a valid option, permitted choices are: ' + choices, this.xeg_1.cec_1, this.xeg_1.bec_1);
  }
  oz(descriptor) {
    return 0;
  }
}
//endregion
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new Companion();
  return Companion_instance_1;
}
function encodeToBufferedSink($this, serializer, value, sink) {
  $l$block_0: {
    // Inline function 'kotlin.use' call
    var this_0 = new BufferedSinkDataWriter(sink);
    // Inline function 'kotlin.contracts.contract' call
    var exception = null;
    try {
      $l$block: {
        // Inline function 'kotlin.use' call
        var this_1 = YamlOutput.fe2(this_0, $this.xe1_1, $this.ye1_1);
        // Inline function 'kotlin.contracts.contract' call
        var exception_0 = null;
        try {
          this_1.q10(serializer, value);
          break $l$block;
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            exception_0 = e;
            throw e;
          } else {
            throw $p;
          }
        }
        finally {
          closeFinally(this_1, exception_0);
        }
      }
      break $l$block_0;
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        exception = e_0;
        throw e_0;
      } else {
        throw $p;
      }
    }
    finally {
      closeFinally(this_0, exception);
    }
  }
}
var SingleLineStringStyle_DoubleQuoted_instance;
var SingleLineStringStyle_SingleQuoted_instance;
var SingleLineStringStyle_Plain_instance;
var SingleLineStringStyle_PlainExceptAmbiguous_instance;
var SingleLineStringStyle_entriesInitialized;
function SingleLineStringStyle_initEntries() {
  if (SingleLineStringStyle_entriesInitialized)
    return Unit_instance;
  SingleLineStringStyle_entriesInitialized = true;
  SingleLineStringStyle_DoubleQuoted_instance = new SingleLineStringStyle('DoubleQuoted', 0);
  SingleLineStringStyle_SingleQuoted_instance = new SingleLineStringStyle('SingleQuoted', 1);
  SingleLineStringStyle_Plain_instance = new SingleLineStringStyle('Plain', 2);
  SingleLineStringStyle_PlainExceptAmbiguous_instance = new SingleLineStringStyle('PlainExceptAmbiguous', 3);
}
var MultiLineStringStyle_Literal_instance;
var MultiLineStringStyle_DoubleQuoted_instance;
var MultiLineStringStyle_SingleQuoted_instance;
var MultiLineStringStyle_Plain_instance;
var MultiLineStringStyle_entriesInitialized;
function MultiLineStringStyle_initEntries() {
  if (MultiLineStringStyle_entriesInitialized)
    return Unit_instance;
  MultiLineStringStyle_entriesInitialized = true;
  MultiLineStringStyle_Literal_instance = new MultiLineStringStyle('Literal', 0);
  MultiLineStringStyle_DoubleQuoted_instance = new MultiLineStringStyle('DoubleQuoted', 1);
  MultiLineStringStyle_SingleQuoted_instance = new MultiLineStringStyle('SingleQuoted', 2);
  MultiLineStringStyle_Plain_instance = new MultiLineStringStyle('Plain', 3);
}
var PolymorphismStyle_Tag_instance;
var PolymorphismStyle_Property_instance;
var PolymorphismStyle_None_instance;
var PolymorphismStyle_entriesInitialized;
function PolymorphismStyle_initEntries() {
  if (PolymorphismStyle_entriesInitialized)
    return Unit_instance;
  PolymorphismStyle_entriesInitialized = true;
  PolymorphismStyle_Tag_instance = new PolymorphismStyle('Tag', 0);
  PolymorphismStyle_Property_instance = new PolymorphismStyle('Property', 1);
  PolymorphismStyle_None_instance = new PolymorphismStyle('None', 2);
}
var SequenceStyle_Block_instance;
var SequenceStyle_Flow_instance;
var SequenceStyle_entriesInitialized;
function SequenceStyle_initEntries() {
  if (SequenceStyle_entriesInitialized)
    return Unit_instance;
  SequenceStyle_entriesInitialized = true;
  SequenceStyle_Block_instance = new SequenceStyle('Block', 0);
  SequenceStyle_Flow_instance = new SequenceStyle('Flow', 1);
}
var AmbiguousQuoteStyle_DoubleQuoted_instance;
var AmbiguousQuoteStyle_SingleQuoted_instance;
var AmbiguousQuoteStyle_entriesInitialized;
function AmbiguousQuoteStyle_initEntries() {
  if (AmbiguousQuoteStyle_entriesInitialized)
    return Unit_instance;
  AmbiguousQuoteStyle_entriesInitialized = true;
  AmbiguousQuoteStyle_DoubleQuoted_instance = new AmbiguousQuoteStyle('DoubleQuoted', 0);
  AmbiguousQuoteStyle_SingleQuoted_instance = new AmbiguousQuoteStyle('SingleQuoted', 1);
}
function SingleLineStringStyle_DoubleQuoted_getInstance() {
  SingleLineStringStyle_initEntries();
  return SingleLineStringStyle_DoubleQuoted_instance;
}
function SingleLineStringStyle_PlainExceptAmbiguous_getInstance() {
  SingleLineStringStyle_initEntries();
  return SingleLineStringStyle_PlainExceptAmbiguous_instance;
}
function MultiLineStringStyle_DoubleQuoted_getInstance() {
  MultiLineStringStyle_initEntries();
  return MultiLineStringStyle_DoubleQuoted_instance;
}
function MultiLineStringStyle_SingleQuoted_getInstance() {
  MultiLineStringStyle_initEntries();
  return MultiLineStringStyle_SingleQuoted_instance;
}
function MultiLineStringStyle_Plain_getInstance() {
  MultiLineStringStyle_initEntries();
  return MultiLineStringStyle_Plain_instance;
}
function PolymorphismStyle_Tag_getInstance() {
  PolymorphismStyle_initEntries();
  return PolymorphismStyle_Tag_instance;
}
function PolymorphismStyle_Property_getInstance() {
  PolymorphismStyle_initEntries();
  return PolymorphismStyle_Property_instance;
}
function PolymorphismStyle_None_getInstance() {
  PolymorphismStyle_initEntries();
  return PolymorphismStyle_None_instance;
}
function SequenceStyle_Block_getInstance() {
  SequenceStyle_initEntries();
  return SequenceStyle_Block_instance;
}
function AmbiguousQuoteStyle_DoubleQuoted_getInstance() {
  AmbiguousQuoteStyle_initEntries();
  return AmbiguousQuoteStyle_DoubleQuoted_instance;
}
function createContextual($this, node, yaml, context, configuration, descriptor) {
  var tmp5_safe_receiver = getContextualDescriptor(context, descriptor);
  var tmp;
  if (tmp5_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.charleskorn.kaml.Companion.createContextual.<anonymous>' call
    tmp = Companion_getInstance_1().je2(node, yaml, context, configuration, tmp5_safe_receiver);
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? new YamlContextualInput(node, yaml, context, configuration) : tmp0_elvis_lhs;
}
function createPolymorphicMapDeserializer($this, node, yaml, context, configuration) {
  var desiredKey = configuration.se2_1;
  var typeName = getValue(node, $this, desiredKey);
  if (typeName instanceof YamlList)
    throw InvalidPropertyValueException.ve5(desiredKey, 'expected a string, but got a list', typeName.lec_1);
  else {
    if (typeName instanceof YamlMap)
      throw InvalidPropertyValueException.ve5(desiredKey, 'expected a string, but got a map', typeName.iec_1);
    else {
      if (typeName instanceof YamlNull)
        throw InvalidPropertyValueException.ve5(desiredKey, 'expected a string, but got a null value', typeName.fec_1);
      else {
        if (typeName instanceof YamlTaggedNode)
          throw InvalidPropertyValueException.ve5(desiredKey, 'expected a string, but got a tagged value', typeName.d3e());
        else {
          if (typeName instanceof YamlScalar) {
            var remainingProperties = withoutKey(node, $this, desiredKey);
            return new YamlPolymorphicInput(typeName.bec_1, typeName.cec_1, remainingProperties, yaml, context, configuration);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
}
function getValue(_this__u8e3s4, $this, desiredKey) {
  var tmp0_elvis_lhs = _this__u8e3s4.mec(desiredKey);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw MissingRequiredPropertyException.je6(desiredKey, _this__u8e3s4.iec_1);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function withoutKey(_this__u8e3s4, $this, key) {
  // Inline function 'kotlin.collections.filterKeys' call
  var this_0 = _this__u8e3s4.hec_1;
  var result = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = this_0.u1().b1();
  while (tmp0_iterator.c1()) {
    var entry = tmp0_iterator.d1();
    // Inline function 'com.charleskorn.kaml.Companion.withoutKey.<anonymous>' call
    if (!(entry.v1().bec_1 === key)) {
      result.k3(entry.v1(), entry.w1());
    }
  }
  return _this__u8e3s4.nec(result);
}
var Companion_instance_2;
function Companion_getInstance_1() {
  if (Companion_instance_2 === VOID)
    new Companion_0();
  return Companion_instance_2;
}
function throwIfMissingRequiredPropertyException($this, e) {
  var tmp0_elvis_lhs = Companion_getInstance_1().ie2_1.vi(ensureNotNull(e.message));
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var match = tmp;
  throw MissingRequiredPropertyException.je6(match.tj().h1(1), $this.ke2_1.d3e(), e);
}
function get_friendlyDescription(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof MAP) {
    tmp = 'a map';
  } else {
    if (_this__u8e3s4 instanceof CLASS) {
      tmp = 'an object';
    } else {
      if (_this__u8e3s4 instanceof OBJECT) {
        tmp = 'an object';
      } else {
        if (_this__u8e3s4 instanceof LIST) {
          tmp = 'a list';
        } else {
          if (_this__u8e3s4 instanceof STRING) {
            tmp = 'a string';
          } else {
            if (_this__u8e3s4 instanceof BOOLEAN) {
              tmp = 'a boolean';
            } else {
              if (_this__u8e3s4 instanceof BYTE) {
                tmp = 'a byte';
              } else {
                if (_this__u8e3s4 instanceof CHAR) {
                  tmp = 'a character';
                } else {
                  if (_this__u8e3s4 instanceof DOUBLE) {
                    tmp = 'a double';
                  } else {
                    if (_this__u8e3s4 instanceof FLOAT) {
                      tmp = 'a float';
                    } else {
                      if (_this__u8e3s4 instanceof INT) {
                        tmp = 'an integer';
                      } else {
                        if (_this__u8e3s4 instanceof SHORT) {
                          tmp = 'a short';
                        } else {
                          if (_this__u8e3s4 instanceof LONG) {
                            tmp = 'a long';
                          } else {
                            if (_this__u8e3s4 instanceof ENUM) {
                              tmp = 'an enumeration value';
                            } else {
                              tmp = 'a ' + _this__u8e3s4.toString() + ' value';
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function _get_currentElementDecoder__u73r00($this) {
  var tmp = $this.xec_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('currentElementDecoder');
  }
}
function _get_haveStartedReadingElements__wj0go1($this) {
  return $this.wec_1 > 0;
}
function _get_currentEntry__q2u5ma($this) {
  var tmp = $this.hed_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('currentEntry');
  }
}
function YamlMapInput$beginStructure$lambda($descriptor) {
  return function ($this$fromCurrentValue) {
    return $this$fromCurrentValue.xy($descriptor);
  };
}
function YamlMapLikeInputBase$decodeNotNullMark$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.iy();
}
function YamlMapLikeInputBase$decodeString$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.sy();
}
function YamlMapLikeInputBase$decodeInt$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.ny();
}
function YamlMapLikeInputBase$decodeLong$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.oy();
}
function YamlMapLikeInputBase$decodeShort$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.my();
}
function YamlMapLikeInputBase$decodeByte$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.ly();
}
function YamlMapLikeInputBase$decodeDouble$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.qy();
}
function YamlMapLikeInputBase$decodeFloat$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.py();
}
function YamlMapLikeInputBase$decodeBoolean$lambda($this$fromCurrentValue) {
  return $this$fromCurrentValue.ky();
}
function YamlMapLikeInputBase$decodeChar$lambda($this$fromCurrentValue) {
  return new Char($this$fromCurrentValue.ry());
}
function YamlMapLikeInputBase$decodeEnum$lambda($enumDescriptor) {
  return function ($this$fromCurrentValue) {
    return $this$fromCurrentValue.ty($enumDescriptor);
  };
}
function convertToIntegerLikeValue($this, converter, description) {
  try {
    var tmp;
    if (startsWith($this.bec_1, '0x')) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = converter($this.bec_1.substring(2), 16);
    } else if (startsWith($this.bec_1, '-0x')) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = converter('-' + $this.bec_1.substring(3), 16);
    } else if (startsWith($this.bec_1, '0o')) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = converter($this.bec_1.substring(2), 8);
    } else if (startsWith($this.bec_1, '-0o')) {
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = converter('-' + $this.bec_1.substring(3), 8);
    } else {
      tmp = converter($this.bec_1, 10);
    }
    return tmp;
  } catch ($p) {
    if ($p instanceof NumberFormatException) {
      var e = $p;
      throw YamlScalarFormatException.ne9("Value '" + $this.bec_1 + "' is not a valid " + description + ' value.', $this.cec_1, $this.bec_1);
    } else {
      throw $p;
    }
  }
}
function toByte$ref() {
  var l = function (p0, p1) {
    return toByte(p0, p1);
  };
  l.callableName = 'toByte';
  return l;
}
function toShort$ref() {
  var l = function (p0, p1) {
    return toShort(p0, p1);
  };
  l.callableName = 'toShort';
  return l;
}
function toInt$ref() {
  var l = function (p0, p1) {
    return toInt(p0, p1);
  };
  l.callableName = 'toInt';
  return l;
}
function toLong$ref() {
  var l = function (p0, p1) {
    return toLong(p0, p1);
  };
  l.callableName = 'toLong';
  return l;
}
function YamlMap$lambda(a, b) {
  var lineComparison = compareTo(a.ued().ue1_1, b.ued().ue1_1);
  var tmp;
  if (!(lineComparison === 0)) {
    tmp = lineComparison;
  } else {
    tmp = compareTo(a.ued().ve1_1, b.ued().ve1_1);
  }
  return tmp;
}
function readNode($this, path) {
  return readNodeAndAnchor($this, path).nm_1;
}
function readNodeAndAnchor($this, path) {
  var event = $this.de3_1.iee(path);
  var node = readFromEvent($this, event, path);
  if (event instanceof NodeEvent) {
    var tmp13_safe_receiver = event.kdo_1;
    if (tmp13_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'com.charleskorn.kaml.YamlNodeReader.readNodeAndAnchor.<anonymous>' call
      if (!$this.fe3_1) {
        throw ForbiddenAnchorOrAliasException.we7('Parsing anchors and aliases is disabled.', path);
      }
      $this.ge3_1.k3(tmp13_safe_receiver, node.ved(Companion_getInstance_3().kee(tmp13_safe_receiver.idl_1, _get_location__4pgxiu(event, $this))));
    }
    return to(node, event.kdo_1);
  }
  return to(node, null);
}
function readFromEvent($this, event, path) {
  var tmp;
  if (event instanceof ScalarEvent) {
    tmp = maybeToTaggedNode(readScalarOrNull($this, event, path), $this, event.edo_1);
  } else {
    if (event instanceof SequenceStartEvent) {
      tmp = maybeToTaggedNode(readSequence($this, path), $this, event.xdo_1);
    } else {
      if (event instanceof MappingStartEvent) {
        tmp = maybeToTaggedNode(readMapping($this, path), $this, event.xdo_1);
      } else {
        if (event instanceof AliasEvent) {
          tmp = readAlias($this, event, path);
        } else {
          throw MalformedYamlException.je7('Unexpected ' + event.gdk().toString(), path.lee(_get_location__4pgxiu(event, $this)));
        }
      }
    }
  }
  return tmp;
}
function readScalarOrNull($this, event, path) {
  if ((event.gdo_1 === 'null' || event.gdo_1 === '' || event.gdo_1 === '~') && event.bdq()) {
    return new YamlNull(path);
  } else {
    return new YamlScalar(event.gdo_1, path);
  }
}
function readSequence($this, path) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var items = ArrayList.z();
  while (true) {
    var event = $this.de3_1.mee(path);
    if (event.gdk().p3_1 === 7) {
      $this.de3_1.oee(ID_SequenceEnd_getInstance(), path);
      return new YamlList(items, path);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var element = readNode($this, path.nee(items.g1(), _get_location__4pgxiu(event, $this)));
      items.h(element);
    }
  }
}
function readMapping($this, path) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var items = LinkedHashMap.wc();
  while (true) {
    var event = $this.de3_1.mee(path);
    if (event.gdk().p3_1 === 4) {
      $this.de3_1.oee(ID_MappingEnd_getInstance(), path);
      return new YamlMap(doMerges($this, items), path);
    } else {
      var keyLocation = _get_location__4pgxiu($this.de3_1.mee(path), $this);
      var key = readMapKey($this, path);
      var keyNode = new YamlScalar(key, path.pee(key, keyLocation));
      var valueLocation = _get_location__4pgxiu($this.de3_1.mee(keyNode.cec_1), $this);
      var valuePath = isMerge($this, keyNode) ? path.ree(valueLocation) : keyNode.cec_1.qee(valueLocation);
      var _destruct__k2r9zo = readNodeAndAnchor($this, valuePath);
      var value = _destruct__k2r9zo.em();
      var anchor = _destruct__k2r9zo.fm();
      if (path.equals(Companion_getInstance_3().jee_1) && !($this.ee3_1 == null) && startsWith(key, $this.ee3_1)) {
        if (anchor == null) {
          throw NoAnchorForExtensionException.le8(key, $this.ee3_1, path.lee(_get_location__4pgxiu(event, $this)));
        }
      } else {
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(keyNode, value);
        items.k3(pair.nm_1, pair.om_1);
      }
    }
  }
}
function readMapKey($this, path) {
  var event = $this.de3_1.mee(path);
  if (event.gdk().p3_1 === 6) {
    $this.de3_1.oee(ID_Scalar_getInstance(), path);
    var scalarEvent = event instanceof ScalarEvent ? event : THROW_CCE();
    var isNullKey = (scalarEvent.gdo_1 === 'null' || scalarEvent.gdo_1 === '~') && scalarEvent.bdq();
    if (!(scalarEvent.edo_1 == null) || isNullKey) {
      throw nonScalarMapKeyException($this, path, event);
    }
    return scalarEvent.gdo_1;
  } else
    throw nonScalarMapKeyException($this, path, event);
}
function nonScalarMapKeyException($this, path, event) {
  return MalformedYamlException.je7("Property name must not be a list, map, null or tagged value. (To use 'null' as a property name, enclose it in quotes.)", path.lee(_get_location__4pgxiu(event, $this)));
}
function maybeToTaggedNode(_this__u8e3s4, $this, tag) {
  var tmp;
  if (tag == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.charleskorn.kaml.YamlNodeReader.maybeToTaggedNode.<anonymous>' call
    tmp = new YamlTaggedNode(tag, _this__u8e3s4);
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
}
function doMerges($this, items) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = items.u1();
  var destination = ArrayList.z();
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.v1();
    if (isMerge($this, key)) {
      destination.h(element);
    }
  }
  var mergeEntries = destination;
  // Inline function 'kotlin.collections.count' call
  switch (mergeEntries.g1()) {
    case 0:
      return items;
    case 1:
      var mappingsToMerge = single(mergeEntries).w1();
      if (mappingsToMerge instanceof YamlList)
        return doMerges_0($this, items, mappingsToMerge.kec_1);
      else {
        return doMerges_0($this, items, listOf(mappingsToMerge));
      }

    default:
      throw MalformedYamlException.je7("Cannot perform multiple '<<' merges into a map. Instead, combine all merges into a single '<<' entry.", second(mergeEntries, $this).v1().cec_1);
  }
}
function isMerge($this, key) {
  var tmp;
  if (key instanceof YamlScalar) {
    tmp = key.bec_1 === '<<';
  } else {
    tmp = false;
  }
  return tmp;
}
function doMerges_0($this, original, others) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var merged = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.filterNot' call
  // Inline function 'kotlin.collections.filterNotTo' call
  var destination = LinkedHashMap.wc();
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator = original.u1().b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key = element.v1();
    if (!isMerge($this, key)) {
      destination.k3(element.v1(), element.w1());
    }
  }
  // Inline function 'kotlin.collections.iterator' call
  var tmp0_iterator_0 = destination.u1().b1();
  while (tmp0_iterator_0.c1()) {
    var element_0 = tmp0_iterator_0.d1();
    // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>' call
    // Inline function 'kotlin.collections.component1' call
    var key_0 = element_0.v1();
    // Inline function 'kotlin.collections.component2' call
    var value = element_0.w1();
    merged.k3(key_0, value);
  }
  // Inline function 'kotlin.collections.forEach' call
  var tmp0_iterator_1 = others.b1();
  while (tmp0_iterator_1.c1()) {
    var element_1 = tmp0_iterator_1.d1();
    // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>' call
    if (element_1 instanceof YamlNull)
      throw MalformedYamlException.je7('Cannot merge a null value into a map.', element_1.fec_1);
    else {
      if (element_1 instanceof YamlScalar)
        throw MalformedYamlException.je7('Cannot merge a scalar value into a map.', element_1.cec_1);
      else {
        if (element_1 instanceof YamlList)
          throw MalformedYamlException.je7('Cannot merge a list value into a map.', element_1.lec_1);
        else {
          if (element_1 instanceof YamlTaggedNode)
            throw MalformedYamlException.je7('Cannot merge a tagged value into a map.', element_1.d3e());
          else {
            if (element_1 instanceof YamlMap) {
              // Inline function 'kotlin.collections.forEach' call
              // Inline function 'kotlin.collections.iterator' call
              var tmp0_iterator_2 = element_1.hec_1.u1().b1();
              while (tmp0_iterator_2.c1()) {
                var element_2 = tmp0_iterator_2.d1();
                // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.collections.component1' call
                var key_1 = element_2.v1();
                // Inline function 'kotlin.collections.component2' call
                var value_0 = element_2.w1();
                var tmp$ret$13;
                $l$block_0: {
                  // Inline function 'kotlin.collections.singleOrNull' call
                  var single = null;
                  var found = false;
                  var tmp0_iterator_3 = merged.u1().b1();
                  while (tmp0_iterator_3.c1()) {
                    var element_3 = tmp0_iterator_3.d1();
                    // Inline function 'com.charleskorn.kaml.YamlNodeReader.doMerges.<anonymous>.<anonymous>.<anonymous>' call
                    if (element_3.v1().yed(key_1)) {
                      if (found) {
                        tmp$ret$13 = null;
                        break $l$block_0;
                      }
                      single = element_3;
                      found = true;
                    }
                  }
                  if (!found) {
                    tmp$ret$13 = null;
                    break $l$block_0;
                  }
                  tmp$ret$13 = single;
                }
                var existingEntry = tmp$ret$13;
                if (existingEntry == null) {
                  merged.k3(key_1, value_0);
                }
              }
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return merged;
}
function readAlias($this, event, path) {
  if (!$this.fe3_1) {
    throw ForbiddenAnchorOrAliasException.we7('Parsing anchors and aliases is disabled.', path);
  }
  var anchor = ensureNotNull(event.kdo_1);
  // Inline function 'kotlin.collections.getOrElse' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp0_elvis_lhs = $this.ge3_1.e3(anchor);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw UnknownAnchorException.ze8(anchor.idl_1, path.lee(_get_location__4pgxiu(event, $this)));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var resolvedNode = tmp;
  return resolvedNode.ved(path.see(anchor.idl_1, _get_location__4pgxiu(event, $this)).tee(anchor.idl_1, resolvedNode.ued()));
}
function second(_this__u8e3s4, $this) {
  return first(drop(_this__u8e3s4, 1));
}
function _get_location__4pgxiu(_this__u8e3s4, $this) {
  return new Location(ensureNotNull(_this__u8e3s4.edk_1).pds_1 + 1 | 0, ensureNotNull(_this__u8e3s4.edk_1).qds_1 + 1 | 0);
}
function _get_pairedPropertyNames__11quvr($this) {
  var tmp = $this.ief_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('pairedPropertyNames');
  }
}
function YamlObjectInput$beginStructure$lambda($descriptor) {
  return function ($this$fromCurrentValue) {
    return $this$fromCurrentValue.xy($descriptor);
  };
}
function emitPlainScalar($this, value) {
  return emitScalar($this, value, ScalarStyle_PLAIN_getInstance());
}
function emitQuotedScalar($this, value, scalarStyle) {
  return emitScalar($this, value, scalarStyle);
}
function encodeComment($this, descriptor, index) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var this_0 = descriptor.dx(index);
  var destination = ArrayList.z();
  var tmp0_iterator = this_0.b1();
  while (tmp0_iterator.c1()) {
    var element = tmp0_iterator.d1();
    if (element instanceof YamlComment) {
      destination.h(element);
    }
  }
  var tmp0_elvis_lhs = firstOrNull(destination);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var commentAnno = tmp;
  var indexedObject = commentAnno.kef_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var line = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    $this.ce2_1.pdq(CommentEvent.cdr(CommentType_BLOCK_getInstance(), ' ' + line, null, null));
  }
}
function emitScalar($this, value, style) {
  var tag = getAndClearTypeName($this);
  if (!(tag == null) && !$this.ae2_1.re2_1.equals(PolymorphismStyle_Tag_getInstance())) {
    throw IllegalStateException.h5('Cannot serialize a polymorphic value that is not a YAML object when using ' + getKClass(PolymorphismStyle).yf() + '.' + $this.ae2_1.re2_1.toString() + '.');
  }
  var implicit = !(tag == null) ? Companion_getInstance_2().mef_1 : Companion_getInstance_2().lef_1;
  $this.ce2_1.pdq(ScalarEvent.rdr(null, tag, implicit, value, style));
}
function getAndClearTypeName($this) {
  var typeName = $this.ee2_1;
  $this.ee2_1 = null;
  return typeName;
}
function isAmbiguous(_this__u8e3s4, $this) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(_this__u8e3s4) === 0) {
    tmp = true;
  } else {
    if (startsWith(_this__u8e3s4, '0x')) {
      tmp = true;
    } else {
      if (startsWith(_this__u8e3s4, '0o')) {
        tmp = true;
      } else {
        if (!(toDoubleOrNull(_this__u8e3s4) == null)) {
          tmp = true;
        } else {
          if (startsWith(_this__u8e3s4, '#')) {
            tmp = true;
          } else {
            tmp = listOf_0(['~', '-', '.inf', '.Inf', '.INF', '-.inf', '-.Inf', '-.INF', '.nan', '.NaN', '.NAN', '-.nan', '-.NaN', '-.NAN', 'null', 'Null', 'NULL', 'true', 'True', 'TRUE', 'false', 'False', 'FALSE']).z2(_this__u8e3s4);
          }
        }
      }
    }
  }
  return tmp;
}
function _get_flowStyle__eylgtu(_this__u8e3s4, $this) {
  var tmp;
  switch (_this__u8e3s4.p3_1) {
    case 0:
      tmp = FlowStyle_BLOCK_getInstance();
      break;
    case 1:
      tmp = FlowStyle_FLOW_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function _get_scalarStyle__245jbg(_this__u8e3s4, $this) {
  var tmp;
  switch (_this__u8e3s4.p3_1) {
    case 1:
      tmp = ScalarStyle_DOUBLE_QUOTED_getInstance();
      break;
    case 2:
      tmp = ScalarStyle_SINGLE_QUOTED_getInstance();
      break;
    case 0:
      tmp = ScalarStyle_LITERAL_getInstance();
      break;
    case 3:
      tmp = ScalarStyle_PLAIN_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function _get_scalarStyle__245jbg_0(_this__u8e3s4, $this) {
  var tmp;
  switch (_this__u8e3s4.p3_1) {
    case 0:
      tmp = ScalarStyle_DOUBLE_QUOTED_getInstance();
      break;
    case 1:
      tmp = ScalarStyle_SINGLE_QUOTED_getInstance();
      break;
    case 2:
      tmp = ScalarStyle_PLAIN_getInstance();
      break;
    case 3:
      tmp = ScalarStyle_PLAIN_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function _get_scalarStyle__245jbg_1(_this__u8e3s4, $this) {
  var tmp;
  switch (_this__u8e3s4.p3_1) {
    case 0:
      tmp = ScalarStyle_DOUBLE_QUOTED_getInstance();
      break;
    case 1:
      tmp = ScalarStyle_SINGLE_QUOTED_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  if (Companion_instance_3 === VOID)
    new Companion_1();
  return Companion_instance_3;
}
function checkEvent($this, path, retrieve) {
  try {
    return retrieve();
  } catch ($p) {
    if ($p instanceof MarkedYamlEngineException) {
      var e = $p;
      throw translateYamlEngineException($this, e, path);
    } else {
      throw $p;
    }
  }
}
function translateYamlEngineException($this, e, path) {
  var updatedMessage = StringBuilder.f();
  var context = e.yds_1;
  var contextMark = e.zds_1;
  if (!(context == null) && !(contextMark == null)) {
    var snippet = contextMark.tds(4, 2147483647);
    updatedMessage.gc(trimMargin('\n                    |' + context + '\n                    | at line ' + (contextMark.pds_1 + 1 | 0) + ', column ' + (contextMark.qds_1 + 1 | 0) + ':\n                    |' + snippet + '\n                    |\n                '));
  }
  var problemMark = e.bdt_1;
  if (!(problemMark == null)) {
    var problem = translateYamlEngineExceptionMessage($this, e.adt_1);
    var snippet_0 = problemMark.tds(4, 2147483647);
    updatedMessage.gc(trimMargin('\n                    |' + problem + '\n                    | at line ' + (problemMark.pds_1 + 1 | 0) + ', column ' + (problemMark.qds_1 + 1 | 0) + ':\n                    |' + snippet_0 + '\n                '));
  }
  var tmp;
  if (!(problemMark == null)) {
    tmp = path.lee(new Location(problemMark.pds_1 + 1 | 0, problemMark.qds_1 + 1 | 0));
  } else {
    tmp = path;
  }
  var updatedPath = tmp;
  return MalformedYamlException.je7(updatedMessage.toString(), updatedPath);
}
function translateYamlEngineExceptionMessage($this, message) {
  switch (message) {
    case 'mapping values are not allowed here':
    case "expected <block end>, but found '<block sequence start>'":
    case "expected <block end>, but found '<block mapping start>'":
      return message + ' (is the indentation level of this line or a line nearby incorrect?)';
    default:
      return message;
  }
}
function YamlParser$consumeEvent$lambda(this$0) {
  return function () {
    return this$0.ke3_1.d1();
  };
}
function YamlParser$peekEvent$lambda(this$0) {
  return function () {
    return this$0.ke3_1.ady();
  };
}
function withSegment($this, segment) {
  return YamlPath.xed(plus_0($this.gea_1, segment));
}
var Companion_instance_4;
function Companion_getInstance_3() {
  if (Companion_instance_4 === VOID)
    new Companion_2();
  return Companion_instance_4;
}
var Root_instance;
function Root_getInstance() {
  if (Root_instance === VOID)
    new Root();
  return Root_instance;
}
var CurrentField_NotStarted_instance;
var CurrentField_Type_instance;
var CurrentField_Content_instance;
var CurrentField_entriesInitialized;
function CurrentField_initEntries() {
  if (CurrentField_entriesInitialized)
    return Unit_instance;
  CurrentField_entriesInitialized = true;
  CurrentField_NotStarted_instance = new CurrentField('NotStarted', 0);
  CurrentField_Type_instance = new CurrentField('Type', 1);
  CurrentField_Content_instance = new CurrentField('Content', 2);
}
function _get_contentDecoder__ypxfj4($this) {
  var tmp = $this.peg_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('contentDecoder');
  }
}
function throwIfUnknownPolymorphicTypeException($this, e, deserializer) {
  var tmp0_elvis_lhs = e.message;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var message = tmp;
  var tmp1_elvis_lhs = Companion_getInstance_4().qeg_1.wi(message, 0);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var match = tmp_0;
  var unknownType = match.tj().h1(1);
  var className = match.tj().h1(2);
  var tmp35_subject = deserializer.yu().gx();
  var tmp_1;
  if (equals(tmp35_subject, SEALED_getInstance())) {
    tmp_1 = getKnownTypesForSealedType($this, deserializer);
  } else if (equals(tmp35_subject, OPEN_getInstance())) {
    tmp_1 = getKnownTypesForOpenType($this, className);
  } else {
    throw IllegalArgumentException.l("Can't get known types for descriptor of kind " + deserializer.yu().gx().toString());
  }
  var knownTypes = tmp_1;
  throw UnknownPolymorphicTypeException.zeb(unknownType, knownTypes, $this.meg_1, e);
}
function getKnownTypesForSealedType($this, deserializer) {
  var typesDescriptor = deserializer.yu().ex(1);
  return toSet(get_elementNames(typesDescriptor));
}
function getKnownTypesForOpenType($this, className) {
  // Inline function 'kotlin.collections.mutableSetOf' call
  var knownTypes = LinkedHashSet.r1();
  var tmp = $this.mz();
  tmp.a1g(new YamlPolymorphicInput$getKnownTypesForOpenType$1(className, knownTypes));
  return knownTypes;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  if (Companion_instance_5 === VOID)
    new Companion_3();
  return Companion_instance_5;
}
function CurrentField_NotStarted_getInstance() {
  CurrentField_initEntries();
  return CurrentField_NotStarted_instance;
}
function CurrentField_Type_getInstance() {
  CurrentField_initEntries();
  return CurrentField_Type_instance;
}
function CurrentField_Content_getInstance() {
  CurrentField_initEntries();
  return CurrentField_Content_instance;
}
function bufferedSource(_this__u8e3s4) {
  return (new Buffer()).ude(Companion_getInstance().sdd(_this__u8e3s4));
}
//region block: post-declaration
initMetadataForClass(Location, 'Location');
initMetadataForCompanion(Companion);
initMetadataForClass(Yaml, 'Yaml', Yaml);
initMetadataForClass(BufferedSinkDataWriter, 'BufferedSinkDataWriter', VOID, VOID, [StreamDataWriter, AutoCloseable]);
initMetadataForClass(YamlComment, 'YamlComment');
initMetadataForClass(YamlConfiguration, 'YamlConfiguration', YamlConfiguration);
initMetadataForClass(SingleLineStringStyle, 'SingleLineStringStyle');
initMetadataForClass(MultiLineStringStyle, 'MultiLineStringStyle');
initMetadataForClass(PolymorphismStyle, 'PolymorphismStyle');
initMetadataForClass(SequenceStyle, 'SequenceStyle');
initMetadataForClass(AmbiguousQuoteStyle, 'AmbiguousQuoteStyle');
initMetadataForClass(YamlInput, 'YamlInput');
initMetadataForClass(YamlContextualInput, 'YamlContextualInput');
initMetadataForClass(YamlException, 'YamlException');
initMetadataForClass(IncorrectTypeException, 'IncorrectTypeException');
initMetadataForClass(MissingTypeTagException, 'MissingTypeTagException');
initMetadataForClass(InvalidPropertyValueException, 'InvalidPropertyValueException');
initMetadataForClass(MissingRequiredPropertyException, 'MissingRequiredPropertyException');
initMetadataForClass(EmptyYamlDocumentException, 'EmptyYamlDocumentException');
initMetadataForClass(MalformedYamlException, 'MalformedYamlException');
initMetadataForClass(ForbiddenAnchorOrAliasException, 'ForbiddenAnchorOrAliasException');
initMetadataForClass(NoAnchorForExtensionException, 'NoAnchorForExtensionException');
initMetadataForClass(UnknownAnchorException, 'UnknownAnchorException');
initMetadataForClass(YamlScalarFormatException, 'YamlScalarFormatException');
initMetadataForClass(DuplicateKeyException, 'DuplicateKeyException');
initMetadataForClass(UnexpectedNullValueException, 'UnexpectedNullValueException');
initMetadataForClass(UnknownPropertyException, 'UnknownPropertyException');
initMetadataForClass(UnknownPolymorphicTypeException, 'UnknownPolymorphicTypeException');
initMetadataForCompanion(Companion_0);
initMetadataForClass(YamlListInput, 'YamlListInput');
initMetadataForClass(YamlMapLikeInputBase, 'YamlMapLikeInputBase');
initMetadataForClass(YamlMapInput, 'YamlMapInput');
initMetadataForClass(YamlNode, 'YamlNode');
initMetadataForClass(YamlNull, 'YamlNull');
initMetadataForClass(YamlScalar, 'YamlScalar');
initMetadataForClass(YamlList, 'YamlList');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(YamlMap, 'YamlMap');
initMetadataForClass(YamlTaggedNode, 'YamlTaggedNode');
initMetadataForClass(YamlNodeReader, 'YamlNodeReader');
initMetadataForClass(YamlNullInput, 'YamlNullInput');
initMetadataForClass(YamlObjectInput, 'YamlObjectInput');
initMetadataForCompanion(Companion_1);
initMetadataForClass(YamlOutput, 'YamlOutput', VOID, VOID, [AbstractEncoder, AutoCloseable]);
initMetadataForClass(YamlParser, 'YamlParser');
initMetadataForCompanion(Companion_2);
initMetadataForClass(YamlPath, 'YamlPath');
initMetadataForClass(YamlPathSegment, 'YamlPathSegment');
initMetadataForObject(Root, 'Root');
initMetadataForClass(ListEntry, 'ListEntry');
initMetadataForClass(MapElementKey, 'MapElementKey');
initMetadataForClass(MapElementValue, 'MapElementValue');
initMetadataForClass(AliasReference, 'AliasReference');
initMetadataForClass(AliasDefinition, 'AliasDefinition');
initMetadataForClass(Merge, 'Merge');
initMetadataForClass(Error_0, 'Error');
initMetadataForClass(CurrentField, 'CurrentField');
initMetadataForCompanion(Companion_3);
protoOf(YamlPolymorphicInput$getKnownTypesForOpenType$1).l1g = contextual;
initMetadataForClass(YamlPolymorphicInput$getKnownTypesForOpenType$1, VOID, VOID, VOID, [SerializersModuleCollector]);
initMetadataForClass(YamlPolymorphicInput, 'YamlPolymorphicInput');
initMetadataForClass(YamlScalarInput, 'YamlScalarInput');
//endregion
//region block: exports
export {
  YamlConfiguration as YamlConfiguration3kgm4apcoewiu,
  Yaml as Yaml1rldhjqe94g1k,
  MultiLineStringStyle_DoubleQuoted_getInstance as MultiLineStringStyle_DoubleQuoted_getInstance12oe3v2grr0jt,
  PolymorphismStyle_Property_getInstance as PolymorphismStyle_Property_getInstance16g9b3ph2m4l0,
  SingleLineStringStyle_DoubleQuoted_getInstance as SingleLineStringStyle_DoubleQuoted_getInstance8300f2c5a36k,
};
//endregion
